import React, { Component } from 'react';

import PropTypes from 'prop-types';

import axios from 'axios';

import {

    Typography,

    Button,

    TextField,

    Select,

    MenuItem,

    FormControl,

    InputLabel,

    Checkbox,

    FormControlLabel,

    CircularProgress,

    Paper,

    Chip,

    Divider,

    Tooltip,

    IconButton,

    Dialog,

    DialogTitle,

    DialogContent,

    DialogActions,

    Menu,

    Popover,

    Tabs,

    Tab

} from '@material-ui/core';

import {

    ArrowUpward as ArrowUpIcon,

    ArrowDownward as ArrowDownIcon,

    DeleteOutline as DeleteIcon,

    FormatBold as FormatBoldIcon,

    FormatItalic as FormatItalicIcon,

    FormatUnderlined as FormatUnderlinedIcon,

    FormatListBulleted as FormatListBulletedIcon,

    FormatListNumbered as FormatListNumberedIcon,

    FormatAlignLeft as FormatAlignLeftIcon,

    FormatAlignCenter as FormatAlignCenterIcon,

    FormatAlignRight as FormatAlignRightIcon,

    Link as LinkIcon,

    FormatClear as FormatClearIcon,

    FormatStrikethrough as FormatStrikethroughIcon,

    FormatQuote as FormatQuoteIcon,

    FormatIndentIncrease as FormatIndentIncreaseIcon,

    FormatIndentDecrease as FormatIndentDecreaseIcon,

    FormatAlignJustify as FormatAlignJustifyIcon,

    Code as CodeIcon,

    TextFields as TextFieldsIcon,

    Add as AddIcon,

    Remove as HorizontalRuleIcon,

    MoreHoriz as MoreHorizIcon

} from '@material-ui/icons';

const apiBaseUrl = process.env.REACT_APP_API_URL || '';



function toYoutubeEmbedUrl(input) {

    if (!input) return '';

    const trimmed = input.trim();

    const match = trimmed.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);

    if (match) return `https://www.youtube.com/embed/${match[1]}`;

    if (/^[\w-]{11}$/.test(trimmed)) return `https://www.youtube.com/embed/${trimmed}`;

    if (trimmed.startsWith('https://www.youtube.com/embed/')) return trimmed;

    return '';

}



const LAYOUT_SNIPPETS = [

    {

        id: 'paragraph',

        label: 'Paragraph',

        html: '<p><br></p>'

    },

    {

        id: 'cols2',

        label: '2 columns',

        html: `<div class="jx-tab-cols jx-tab-cols-2">

  <div class="jx-tab-col"><p>Left column content</p></div>

  <div class="jx-tab-col"><p>Right column content</p></div>

</div>`

    },

    {

        id: 'cols3',

        label: '3 columns',

        html: `<div class="jx-tab-cols jx-tab-cols-3">

  <div class="jx-tab-col"><p>Column 1</p></div>

  <div class="jx-tab-col"><p>Column 2</p></div>

  <div class="jx-tab-col"><p>Column 3</p></div>

</div>`

    },

    {

        id: 'image',

        label: 'Image',

        action: 'image'

    },

    {

        id: 'imgText',

        label: 'Image + text',

        html: `<div class="jx-tab-cols jx-tab-cols-2 jx-tab-img-text">

  <div class="jx-tab-col"><img src="https://" alt="Product image" loading="lazy" /></div>

  <div class="jx-tab-col"><h3>Heading</h3><p>Describe the product feature here.</p></div>

</div>`

    },

    {

        id: 'videoText',

        label: 'Video + text',

        html: `<div class="jx-tab-cols jx-tab-cols-2 jx-tab-video-text">

  <div class="jx-tab-col"><div class="jx-tab-video"><iframe src="https://www.youtube.com/embed/VIDEO_ID" title="Video" allowfullscreen></iframe></div></div>

  <div class="jx-tab-col"><h3>Heading</h3><p>Video description or install notes.</p></div>

</div>`

    },

    {

        id: 'youtube',

        label: 'YouTube',

        action: 'video'

    },

    {

        id: 'callout',

        label: 'Callout',

        html: `<div class="jx-tab-callout"><p><strong>Note:</strong> Important information for customers.</p></div>`

    },

    {

        id: 'table',

        label: 'Table',

        html: `<table class="jx-tab-table">

  <thead><tr><th>Item</th><th>Details</th></tr></thead>

  <tbody><tr><td>Row 1</td><td></td></tr><tr><td>Row 2</td><td></td></tr></tbody>

</table>`

    },

    {

        id: 'divider',

        label: 'Divider',

        html: '<hr class="jx-tab-divider" />'

    }

];



const DEFAULT_TEMPLATE_TABS = [

    { sortOrder: 0, tabKey: 'what-it-does', title: 'What It Does', htmlContent: '<p></p>', isVisible: true },

    { sortOrder: 1, tabKey: 'videos', title: 'Videos', htmlContent: '<p></p>', isVisible: true },

    { sortOrder: 2, tabKey: 'installation', title: 'Installation', htmlContent: '<p></p>', isVisible: true },

    { sortOrder: 3, tabKey: 'fitment', title: 'Fitment', htmlContent: '<p></p>', isVisible: true },

    { sortOrder: 4, tabKey: 'street-vs-track', title: 'Street vs Track', htmlContent: '<p></p>', isVisible: true },

    { sortOrder: 5, tabKey: 'parts', title: 'Parts', htmlContent: '<p></p>', isVisible: true }

];



function normalizeTabs(tabs) {

    return (Array.isArray(tabs) ? tabs : []).map((t, i) => ({

        tabKey: t.tabKey || `tab-${i}`,

        title: t.title || '',

        htmlContent: t.htmlContent || '',

        sortOrder: typeof t.sortOrder === 'number' ? t.sortOrder : i,

        isVisible: t.isVisible !== false

    }));

}



function appendHtml(current, snippet) {

    const base = (current || '').trim();

    if (!base) return snippet;

    return `${base}\n\n${snippet}`;

}



function insertHtmlAtPosition(current, snippet, start, end) {

    const text = current || '';

    const safeStart = Math.max(0, Math.min(start, text.length));

    const safeEnd = Math.max(safeStart, Math.min(end, text.length));

    return text.slice(0, safeStart) + snippet + text.slice(safeEnd);

}



function editorKey(scope, index) {

    return `${scope}-${index}`;

}



function normalizeEditorMode(mode) {

    if (mode === 'visual') return 'design';

    return mode === 'html' ? 'html' : 'design';

}



function selectionIsInsideElement(element) {

    const selection = window.getSelection();

    if (!selection || selection.rangeCount === 0 || !element) return false;

    const anchor = selection.anchorNode;

    return anchor ? element.contains(anchor) : false;

}



function insertHtmlIntoContentEditable(element, html) {

    element.focus();

    if (typeof document.execCommand === 'function' && document.queryCommandSupported('insertHTML')) {

        return document.execCommand('insertHTML', false, html);

    }

    const selection = window.getSelection();

    if (!selection || selection.rangeCount === 0) return false;

    const range = selection.getRangeAt(0);

    range.deleteContents();

    const fragment = range.createContextualFragment(html);

    range.insertNode(fragment);

    range.collapse(false);

    selection.removeAllRanges();

    selection.addRange(range);

    return true;

}



const QL_ALIGN_CLASSES = ['ql-align-center', 'ql-align-right', 'ql-align-justify'];

const QL_SIZE_CLASSES = ['ql-size-small', 'ql-size-large', 'ql-size-huge'];

const DESIGN_TEXT_STYLES = [
    { id: 'p1', label: 'Paragraph 1', block: 'p' },
    { id: 'p2', label: 'Paragraph 2', block: 'p', sizeClass: 'ql-size-small' },
    { id: 'h1', label: 'Heading 1', block: 'h1' },
    { id: 'h2', label: 'Heading 2', block: 'h2' },
    { id: 'h3', label: 'Heading 3', block: 'h3' },
    { id: 'h4', label: 'Heading 4', block: 'h4' }
];

const DESIGN_TEXT_COLORS = [
    { label: 'White', value: '#ffffff' },
    { label: 'Muted', value: '#cccccc' },
    { label: 'Accent', value: '#00e5ff' },
    { label: 'Black', value: '#000000' }
];

const EMPTY_PARAGRAPH_HTML = '<p><br></p>';



function normalizeHexColor(input) {

    const raw = String(input || '').trim();

    if (!raw) return '';

    const withHash = raw.startsWith('#') ? raw : `#${raw}`;

    if (/^#[0-9a-fA-F]{3}$/.test(withHash)) {

        return `#${withHash[1]}${withHash[1]}${withHash[2]}${withHash[2]}${withHash[3]}${withHash[3]}`.toLowerCase();

    }

    if (/^#[0-9a-fA-F]{6}$/.test(withHash)) {

        return withHash.toLowerCase();

    }

    return '';

}



function rgbStringToHex(value) {

    const normalized = normalizeHexColor(value);

    if (normalized) return normalized;

    const match = String(value || '').match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);

    if (!match) return '';

    const toHex = (n) => Math.max(0, Math.min(255, parseInt(n, 10))).toString(16).padStart(2, '0');

    return `#${toHex(match[1])}${toHex(match[2])}${toHex(match[3])}`;

}



function getDesignSelectionForeColor(canvas) {

    if (!canvas) return '#ffffff';

    const focused = document.activeElement === canvas || canvas.contains(document.activeElement);

    if (focused) {

        try {

            const commandValue = document.queryCommandValue('foreColor');

            const fromCommand = rgbStringToHex(commandValue);

            if (fromCommand) return fromCommand;

        } catch (e) {

            /* ignore */

        }

    }

    const selection = window.getSelection();

    if (!selection || selection.rangeCount === 0) return '#ffffff';

    let node = selection.anchorNode;

    if (!node) return '#ffffff';

    if (node.nodeType === Node.TEXT_NODE) node = node.parentElement;

    while (node && node !== canvas) {

        if (node.style && node.style.color) {

            const fromStyle = rgbStringToHex(node.style.color);

            if (fromStyle) return fromStyle;

        }

        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'FONT' && node.getAttribute('color')) {

            const fromFont = rgbStringToHex(node.getAttribute('color'));

            if (fromFont) return fromFont;

        }

        const computed = window.getComputedStyle(node).color;

        const fromComputed = rgbStringToHex(computed);

        if (fromComputed && fromComputed !== '#000000') return fromComputed;

        node = node.parentElement;

    }

    return '#ffffff';

}



function resolveDesignTableElement(sectionBlock) {

    if (!sectionBlock) return null;

    if (sectionBlock.tagName === 'TABLE' && sectionBlock.classList.contains('jx-tab-table')) return sectionBlock;

    return sectionBlock.querySelector ? sectionBlock.querySelector('table.jx-tab-table') : null;

}



function getTableColumnCount(table) {

    if (!table) return 1;

    const headerRow = table.querySelector('thead tr');

    if (headerRow && headerRow.cells.length) return headerRow.cells.length;

    const firstBodyRow = table.querySelector('tbody tr');

    if (firstBodyRow && firstBodyRow.cells.length) return firstBodyRow.cells.length;

    const firstRow = table.querySelector('tr');

    return firstRow && firstRow.cells.length ? firstRow.cells.length : 1;

}



function getTableBodyRows(table) {

    if (!table) return [];

    const tbody = table.querySelector('tbody');

    if (tbody) return [...tbody.querySelectorAll('tr')];

    return [...table.querySelectorAll('tr')].filter((row) => !row.closest('thead'));

}



function ensureTableStructure(table) {

    if (!table) return null;

    let thead = table.querySelector('thead');

    let tbody = table.querySelector('tbody');



    [...table.querySelectorAll(':scope > tr')].forEach((row) => {

        if (!tbody) {

            tbody = document.createElement('tbody');

            table.appendChild(tbody);

        }

        tbody.appendChild(row);

    });



    if (!tbody) {

        tbody = document.createElement('tbody');

        table.appendChild(tbody);

    }



    if (!thead) {

        const colCount = Math.max(getTableColumnCount(table), 1);

        thead = document.createElement('thead');

        const headerRow = document.createElement('tr');

        for (let i = 0; i < colCount; i += 1) {

            const th = document.createElement('th');

            th.textContent = i === 0 ? 'Item' : `Column ${i + 1}`;

            headerRow.appendChild(th);

        }

        thead.appendChild(headerRow);

        table.insertBefore(thead, tbody);

    }



    return { thead, tbody };

}



function addTableRow(table) {

    ensureTableStructure(table);

    const tbody = table.querySelector('tbody');

    if (!tbody) return;

    const tr = document.createElement('tr');

    const colCount = getTableColumnCount(table);

    for (let i = 0; i < colCount; i += 1) {

        const td = document.createElement('td');

        td.appendChild(document.createTextNode('\u00a0'));

        tr.appendChild(td);

    }

    tbody.appendChild(tr);

}



function removeTableRow(table) {

    ensureTableStructure(table);

    const rows = getTableBodyRows(table);

    if (rows.length <= 1) return false;

    rows[rows.length - 1].remove();

    return true;

}



function addTableColumn(table) {

    ensureTableStructure(table);

    const colCount = getTableColumnCount(table);

    const headerRow = table.querySelector('thead tr');

    if (headerRow) {

        const th = document.createElement('th');

        th.textContent = `Column ${colCount + 1}`;

        headerRow.appendChild(th);

    }

    getTableBodyRows(table).forEach((row) => {

        const td = document.createElement('td');

        td.appendChild(document.createTextNode('\u00a0'));

        row.appendChild(td);

    });

}



function removeTableColumn(table) {

    if (getTableColumnCount(table) <= 1) return false;

    const headerRow = table.querySelector('thead tr');

    if (headerRow && headerRow.cells.length) headerRow.deleteCell(-1);

    getTableBodyRows(table).forEach((row) => {

        if (row.cells.length) row.deleteCell(-1);

    });

    return true;

}



function unwrapDesignBlockquote(blockquoteEl) {

    if (!blockquoteEl || !blockquoteEl.parentNode) return null;

    const replacement = document.createElement('p');

    while (blockquoteEl.firstChild) {

        replacement.appendChild(blockquoteEl.firstChild);

    }

    blockquoteEl.parentNode.replaceChild(replacement, blockquoteEl);

    return replacement;

}



function isDesignLayoutBlockElement(el) {

    if (!el || !el.classList) return false;

    return el.classList.contains('jx-tab-cols')

        || el.classList.contains('jx-tab-callout')

        || el.classList.contains('jx-tab-video')

        || el.classList.contains('jx-tab-table')

        || el.classList.contains('jx-tab-divider');

}



function ensureDesignBlockId(blockEl) {

    if (!blockEl) return '';

    let id = blockEl.getAttribute('data-cst-block-id');

    if (!id) {

        id = `cst-b-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

        blockEl.setAttribute('data-cst-block-id', id);

    }

    return id;

}



function findDesignBlockById(canvas, blockId) {

    if (!canvas || !blockId) return null;

    return canvas.querySelector(`[data-cst-block-id="${blockId}"]`);

}



function getDesignLayoutBlocks(canvas) {

    if (!canvas) return [];

    return [...canvas.querySelectorAll('.jx-tab-cols, .jx-tab-callout, .jx-tab-video, hr.jx-tab-divider')]

        .filter(isDesignLayoutBlockElement)

        .concat([...canvas.querySelectorAll('.cst-table-edit-wrap')])

        .concat(

            [...canvas.querySelectorAll('table.jx-tab-table')]

                .filter((table) => !table.closest('.cst-table-edit-wrap'))

        );

}



function findInnermostLayoutBlock(node, canvas) {

    if (!node || !canvas) return null;

    let el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;

    let match = null;

    while (el && el !== canvas) {

        if (isDesignLayoutBlockElement(el)) match = el;

        el = el.parentElement;

    }

    return match;

}



function isLayoutProtectedTopLevel(el) {

    if (!el || !el.classList) return false;

    return isDesignLayoutBlockElement(el) || el.classList.contains('cst-table-edit-wrap');

}



function getCanvasChildFromNode(canvas, node) {

    if (!canvas || !node) return null;

    let el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;

    while (el && el.parentNode !== canvas) el = el.parentNode;

    return el || null;

}



function findParentColumn(node, canvas) {

    if (!node || !canvas) return null;

    let el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;

    const col = el && el.closest ? el.closest('.jx-tab-col') : null;

    if (col && canvas.contains(col)) return col;

    return null;

}



function isRangeAtEndOfElement(range, element) {

    if (!range || !element) return false;

    try {

        const test = range.cloneRange();

        test.selectNodeContents(element);

        test.setStart(range.endContainer, range.endOffset);

        return test.toString().length === 0;

    } catch (e) {

        return false;

    }

}



function isRangeAtStartOfElement(range, element) {

    if (!range || !element) return false;

    try {

        const test = range.cloneRange();

        test.selectNodeContents(element);

        test.setEnd(range.startContainer, range.startOffset);

        return test.toString().length === 0;

    } catch (e) {

        return false;

    }

}



function findDirectColumnBlock(col, node) {

    if (!col || !node) return null;

    let el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;

    while (el && el !== col) {

        if (el.parentElement === col) return el;

        el = el.parentElement;

    }

    return null;

}



function isLayoutSnippetHtml(html) {

    const trimmed = (html || '').trim();

    return /jx-tab-(cols|callout|table|video|divider)/.test(trimmed);

}



function isDesignBlockInsertHtml(html) {

    const trimmed = (html || '').trim();

    return isLayoutSnippetHtml(trimmed) || /^<img[\s>]/i.test(trimmed);

}



function insertLayoutInColumn(col, snippetHtml, range) {

    if (!col) return null;

    let reference = null;

    if (range) {

        reference = findDirectColumnBlock(col, range.startContainer);

    }

    if (reference) {

        return insertHtmlRelative(reference, 'after', snippetHtml);

    }

    col.insertAdjacentHTML('beforeend', snippetHtml.trim());

    return col.lastElementChild;

}



function shouldProtectDesignDeleteKey(canvas, range, key) {

    if (!canvas || !range) return false;

    const isDelete = key === 'Delete';

    const isBackspace = key === 'Backspace';

    if (!isDelete && !isBackspace) return false;

    if (!range.collapsed) {

        const wrapper = document.createElement('div');

        try {

            wrapper.appendChild(range.cloneContents());

        } catch (e) {

            return true;

        }

        if (wrapper.querySelector('.jx-tab-cols, .jx-tab-callout, .jx-tab-video, .jx-tab-table, .cst-table-edit-wrap, hr.jx-tab-divider')) {

            return true;

        }

        return false;

    }

    const col = findParentColumn(range.startContainer, canvas);

    if (col) {

        const directBlock = findDirectColumnBlock(col, range.startContainer);

        if (directBlock) {

            if (isBackspace && isRangeAtStartOfElement(range, directBlock)) {

                return true;

            }

            if (isDelete && isRangeAtEndOfElement(range, directBlock)) {

                const nextInCol = directBlock.nextElementSibling;

                if (nextInCol && (isDesignLayoutBlockElement(nextInCol) || nextInCol.classList.contains('jx-tab-cols'))) {

                    return true;

                }

                if (!nextInCol && directBlock === col.lastElementChild) {

                    return true;

                }

            }

        }

        return false;

    }

    const canvasChild = getCanvasChildFromNode(canvas, range.startContainer);

    if (!canvasChild) return false;

    if (isDelete && isRangeAtEndOfElement(range, canvasChild)) {

        const next = canvasChild.nextElementSibling;

        if (isLayoutProtectedTopLevel(next)) return true;

    }

    if (isBackspace && isRangeAtStartOfElement(range, canvasChild)) {

        const prev = canvasChild.previousElementSibling;

        if (isLayoutProtectedTopLevel(prev)) return true;

    }

    return false;

}



function getDesignLayoutBlockLabel(el) {

    if (!el || !el.classList) return 'Section';

    if (el.classList.contains('jx-tab-cols-3')) return '3 columns';

    if (el.classList.contains('jx-tab-video-text')) return 'Video + text';

    if (el.classList.contains('jx-tab-img-text')) return 'Image + text';

    if (el.classList.contains('jx-tab-cols-2')) return '2 columns';

    if (el.classList.contains('jx-tab-cols')) return 'Columns';

    if (el.classList.contains('jx-tab-callout')) return 'Callout';

    if (el.classList.contains('jx-tab-video')) return 'Video';

    if (el.classList.contains('jx-tab-table') || el.classList.contains('cst-table-edit-wrap')) return 'Table';

    if (el.classList.contains('jx-tab-divider')) return 'Divider';

    return 'Section';

}



function iframeSrcToYoutubeInput(src) {

    if (!src) return '';

    const value = String(src);

    const match = value.match(/(?:embed\/|youtu\.be\/|v=)([\w-]{11})/);

    if (match) return `https://www.youtube.com/watch?v=${match[1]}`;

    return value;

}



function resolveDesignEditableTarget(blockEl) {

    if (!blockEl) return null;

    const tag = blockEl.tagName;

    if (tag && /^(P|H1|H2|H3|H4|H5|H6|LI|BLOCKQUOTE|TD|TH)$/i.test(tag)) {

        return blockEl;

    }

    const preferred = blockEl.querySelector('.jx-tab-col p, .jx-tab-callout p, .jx-tab-video-text p, p, td, th, li');

    if (preferred) return preferred;

    return blockEl;

}



function getDesignBlockHighlightTarget(el) {

    if (!el) return null;

    if (el.classList && el.classList.contains('cst-layout-section-wrap')) return el;

    const wrapped = el.closest ? el.closest('.cst-layout-section-wrap') : null;

    return wrapped || el;

}



function clearDesignBlockHighlight(canvas) {

    if (!canvas) return;

    canvas.querySelectorAll('.is-block-selected').forEach((el) => el.classList.remove('is-block-selected'));

}



function highlightDesignInsertedBlock(canvas, blockEl) {

    const target = getDesignBlockHighlightTarget(blockEl);

    if (!canvas || !target) return;

    clearDesignBlockHighlight(canvas);

    target.classList.add('is-block-selected');

    target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });

}



function getCanvasChildForElement(canvas, el) {

    if (!canvas || !el || !canvas.contains(el)) return null;

    let node = el;

    while (node.parentNode && node.parentNode !== canvas) {

        node = node.parentNode;

    }

    return node;

}



function focusDesignEditableInCanvas(canvas, blockEl) {

    const target = resolveDesignEditableTarget(blockEl);

    if (!canvas || !target) return null;

    canvas.focus();

    const selection = window.getSelection();

    if (!selection) return null;

    const range = document.createRange();

    const text = (target.textContent || '').replace(/\u00a0/g, ' ').trim();

    const isPlaceholder = /^(Left column content|Right column content|Column \d|Cell \d|Callout content)/i.test(text);

    if (isPlaceholder && text.length > 0) {

        range.selectNodeContents(target);

    } else if (target.tagName === 'P' && !text) {

        const firstChild = target.firstChild;

        if (firstChild && firstChild.nodeType === Node.ELEMENT_NODE && firstChild.tagName === 'BR') {

            range.setStart(target, 1);

            range.collapse(true);

        } else {

            range.setStart(target, 0);

            range.collapse(true);

        }

    } else {

        range.selectNodeContents(target);

        range.collapse(false);

    }

    selection.removeAllRanges();

    selection.addRange(range);

    return target;

}



function getDesignMenuAnchorPosition(anchorEl, clickEvent) {

    if (anchorEl && typeof anchorEl.getBoundingClientRect === 'function') {

        const rect = anchorEl.getBoundingClientRect();

        if (rect.width || rect.height || rect.top || rect.left) {

            return { top: rect.bottom, left: rect.left };

        }

    }

    if (clickEvent && typeof clickEvent.clientY === 'number') {

        return { top: clickEvent.clientY, left: clickEvent.clientX };

    }

    return null;

}



function insertHtmlRelative(referenceEl, position, html) {

    if (!referenceEl || !referenceEl.parentNode) return null;

    const template = document.createElement('template');

    template.innerHTML = html.trim();

    const nodes = [...template.content.childNodes];

    const parent = referenceEl.parentNode;

    const insertBeforeNode = position === 'before' ? referenceEl : referenceEl.nextSibling;

    nodes.forEach((node) => parent.insertBefore(node, insertBeforeNode));

    return nodes[0] || null;

}



function insertEmptyParagraphRelative(referenceEl, position) {

    return insertHtmlRelative(referenceEl, position, EMPTY_PARAGRAPH_HTML);

}



function stripDesignEditorArtifacts(canvas) {

    if (!canvas) return;

    canvas.querySelectorAll('.cst-media-edit-overlay, .cst-section-edit-overlay').forEach((el) => el.remove());

    canvas.querySelectorAll('.cst-img-edit-wrap').forEach((wrap) => {

        const img = wrap.querySelector('img');

        if (img && wrap.parentNode) {

            wrap.parentNode.insertBefore(img, wrap);

        }

        wrap.remove();

    });

    canvas.querySelectorAll('.cst-table-edit-wrap').forEach((wrap) => {

        const table = wrap.querySelector('table.jx-tab-table');

        if (table && wrap.parentNode) {

            wrap.parentNode.insertBefore(table, wrap);

        }

        wrap.remove();

    });

    canvas.querySelectorAll('[data-cst-media-ref]').forEach((el) => {

        el.removeAttribute('data-cst-media-ref');

    });

    canvas.querySelectorAll('[data-cst-block-id]').forEach((el) => {

        el.removeAttribute('data-cst-block-id');

    });

    canvas.querySelectorAll('.is-block-selected, .cst-layout-section-wrap, .cst-editable-media-wrap, .cst-media-empty, .cst-table-edit-wrap').forEach((el) => {

        el.classList.remove('is-block-selected', 'cst-layout-section-wrap', 'cst-editable-media-wrap', 'cst-media-empty', 'cst-table-edit-wrap');

    });

}



function isVideoSrcMissing(src) {

    if (!src || !String(src).trim()) return true;

    if (/VIDEO_ID|placeholder|about:blank/i.test(String(src))) return true;

    return !toYoutubeEmbedUrl(src);

}



function createInlineEditButton(label, action) {

    const btn = document.createElement('button');

    btn.type = 'button';

    btn.className = 'cst-inline-edit-btn';

    btn.setAttribute('data-cst-action', action);

    btn.textContent = label;

    btn.contentEditable = 'false';

    return btn;

}



function stripDesignEditorClasses(canvas) {

    stripDesignEditorArtifacts(canvas);

}



function decorateDesignEditorCanvas(canvas) {

    if (!canvas) return;

    stripDesignEditorArtifacts(canvas);



    canvas.querySelectorAll('.jx-tab-video').forEach((videoEl) => {

        videoEl.classList.add('cst-editable-media-wrap');

        const iframe = videoEl.querySelector('iframe');

        const src = iframe ? iframe.getAttribute('src') : '';

        if (isVideoSrcMissing(src)) {

            videoEl.classList.add('cst-media-empty');

        }



        const overlay = document.createElement('div');

        overlay.className = 'cst-media-edit-overlay';

        overlay.contentEditable = 'false';

        overlay.appendChild(createInlineEditButton('Edit Video URL', 'edit-video'));

        videoEl.appendChild(overlay);

    });



    canvas.querySelectorAll('img').forEach((img) => {

        if (img.closest('.cst-img-edit-wrap')) return;

        const wrap = document.createElement('span');

        wrap.className = 'cst-editable-media-wrap cst-img-edit-wrap';

        wrap.contentEditable = 'false';

        img.parentNode.insertBefore(wrap, img);

        wrap.appendChild(img);



        const overlay = document.createElement('div');

        overlay.className = 'cst-media-edit-overlay';

        overlay.contentEditable = 'false';

        overlay.appendChild(createInlineEditButton('Edit Image URL', 'edit-image'));

        wrap.appendChild(overlay);

    });



    canvas.querySelectorAll('table.jx-tab-table').forEach((tableEl) => {

        if (tableEl.closest('.cst-table-edit-wrap')) return;

        const wrap = document.createElement('div');

        wrap.className = 'cst-table-edit-wrap';

        tableEl.parentNode.insertBefore(wrap, tableEl);

        wrap.appendChild(tableEl);

    });



    [...canvas.children].forEach((child) => ensureDesignBlockId(child));



    getDesignLayoutBlocks(canvas).forEach((blockEl) => {

        ensureDesignBlockId(blockEl);

        blockEl.classList.add('cst-layout-section-wrap');

        if (blockEl.querySelector('.cst-section-edit-overlay')) return;

        const overlay = document.createElement('div');

        overlay.className = 'cst-section-edit-overlay';

        overlay.contentEditable = 'false';

        overlay.appendChild(createInlineEditButton('+ Section above', 'section-add-before'));

        overlay.appendChild(createInlineEditButton('+ Section below', 'section-add-after'));

        if (blockEl.querySelector('img')) {

            overlay.appendChild(createInlineEditButton('Edit Image URL', 'edit-image'));

        }

        if (blockEl.classList.contains('cst-table-edit-wrap') || blockEl.classList.contains('jx-tab-table')) {

            overlay.appendChild(createInlineEditButton('+ Row', 'table-add-row'));

            overlay.appendChild(createInlineEditButton('− Row', 'table-remove-row'));

            overlay.appendChild(createInlineEditButton('+ Column', 'table-add-column'));

            overlay.appendChild(createInlineEditButton('− Column', 'table-remove-column'));

        }

        overlay.appendChild(createInlineEditButton('Remove section', 'section-delete'));

        if (blockEl.firstChild) {

            blockEl.insertBefore(overlay, blockEl.firstChild);

        } else {

            blockEl.appendChild(overlay);

        }

    });

}



function getDesignSelectionBlocks(canvas) {

    const selection = window.getSelection();

    if (!selection || selection.rangeCount === 0 || !canvas) return [];

    const blocks = new Set();

    const considerNode = (node) => {

        if (!node || !canvas.contains(node)) return;

        let el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;

        while (el && el !== canvas) {

            const tag = el.tagName;

            if (tag && /^(P|H1|H2|H3|H4|H5|H6|LI|DIV|BLOCKQUOTE)$/i.test(tag)) {

                blocks.add(el);

                break;

            }

            el = el.parentElement;

        }

    };

    considerNode(selection.anchorNode);

    considerNode(selection.focusNode);

    return [...blocks];

}



function detectDesignTextStyleId(block) {

    if (!block) return 'p1';

    const tag = block.tagName.toLowerCase();

    const sizeClass = QL_SIZE_CLASSES.find((cls) => block.classList.contains(cls));

    const match = DESIGN_TEXT_STYLES.find((style) => {

        if ((style.block || 'p') !== tag) return false;

        if (style.sizeClass) return style.sizeClass === sizeClass;

        return !sizeClass;

    });

    return match ? match.id : 'p1';

}



function getDesignFormatState(canvas) {

    const state = {

        bold: false,

        italic: false,

        underline: false,

        strikeThrough: false,

        textStyle: 'p1'

    };

    if (!canvas) return state;

    const focused = document.activeElement === canvas || canvas.contains(document.activeElement);

    if (focused) {

        try {

            state.bold = document.queryCommandState('bold');

            state.italic = document.queryCommandState('italic');

            state.underline = document.queryCommandState('underline');

            state.strikeThrough = document.queryCommandState('strikeThrough');

        } catch (e) {

            /* ignore */

        }

    }

    const blocks = getDesignSelectionBlocks(canvas);

    if (blocks.length > 0) {

        state.textStyle = detectDesignTextStyleId(blocks[0]);

    }

    return state;

}



function getDesignLinkUrlFromRange(canvas, range) {

    if (!canvas || !range) return '';

    let node = range.commonAncestorContainer;

    if (node.nodeType === Node.TEXT_NODE) node = node.parentElement;

    if (node && node.closest) {

        const linkEl = node.closest('a');

        if (linkEl && canvas.contains(linkEl)) {

            return linkEl.getAttribute('href') || '';

        }

    }

    const links = findDesignLinksInRange(canvas, range);

    if (links.length === 1) return links[0].getAttribute('href') || '';

    return '';

}



function findDesignLinksInRange(canvas, range) {

    if (!canvas || !range) return [];

    const links = new Set();

    let node = range.commonAncestorContainer;

    if (node.nodeType === Node.TEXT_NODE) node = node.parentElement;

    if (node && node.closest) {

        const linkEl = node.closest('a');

        if (linkEl && canvas.contains(linkEl)) links.add(linkEl);

    }

    if (!range.collapsed) {

        canvas.querySelectorAll('a').forEach((link) => {

            try {

                if (range.intersectsNode(link)) links.add(link);

            } catch (e) {

                /* ignore */

            }

        });

    }

    return [...links];

}



function unwrapDesignLinks(links) {

    links.forEach((link) => {

        const parent = link.parentNode;

        if (!parent) return;

        while (link.firstChild) parent.insertBefore(link.firstChild, link);

        link.remove();

    });

}



class CustomerSiteProductTabsPanel extends Component {

    htmlEditorRefs = {};

    designEditorRefs = {};

    designEditorSnapshot = {};

    lastFocusedHtmlEditorKey = null;

    lastFocusedDesignEditorKey = null;

    pendingHtmlCursor = null;

    pendingDesignEditorSync = null;

    pendingDesignInsertFocus = null;

    designEditorSelection = {};

    designMediaEditTarget = null;

    static propTypes = {

        embedded: PropTypes.bool,

        productType: PropTypes.oneOf(['assembly', 'subassembly', 'part', 'productlisting']),

        productId: PropTypes.string,

        displayName: PropTypes.string,

        showTemplateManager: PropTypes.bool

    };



    static defaultProps = {

        embedded: false,

        productType: 'assembly',

        productId: '',

        displayName: '',

        showTemplateManager: true

    };



    state = {

        productType: this.props.productType,

        productId: this.props.productId || '',

        loading: false,

        saving: false,

        displayName: this.props.displayName || '',

        isCustomerListed: false,

        tabs: [],

        productDescriptionHtml: '',

        templates: [],

        templateId: '',

        newTemplateName: '',

        editingTemplateId: null,

        editingTemplateName: '',

        editingTemplateTabs: [],

        editingTemplateDescriptionHtml: '',

        editingTemplateActive: true,

        productActiveTabIndex: 0,

        templateActiveTabIndex: 0,

        tabEditorModes: {},

        tabShowPreview: {},

        designToolbarMenu: null,

        designFormatStateByEditor: {},

        designColorPicker: null,

        designBlockDelete: null,

        designBlockInsert: null,

        designMediaDialog: null,

        designLinkDialog: null,

        saveTemplateDialog: null

    };



    componentDidMount() {

        this.loadTemplates();

        if (this.props.embedded && this.props.productId) {

            this.syncFromPropsAndLoad();

        }

        this.boundDesignSelectionHandler = () => {

            const key = this.lastFocusedDesignEditorKey;

            if (!key) return;

            const canvas = this.designEditorRefs[key];

            if (!canvas) return;

            const selection = window.getSelection();

            if (!selection || selection.rangeCount === 0) return;

            if (!canvas.contains(selection.anchorNode)) return;

            this.saveDesignEditorSelection(key, { syncFormatState: true });

        };

        this.boundDesignDocumentMouseUp = () => {

            const key = this.lastFocusedDesignEditorKey;

            if (!key) return;

            window.requestAnimationFrame(() => {

                this.saveDesignEditorSelection(key, { syncFormatState: true });

            });

        };

        document.addEventListener('selectionchange', this.boundDesignSelectionHandler);

        document.addEventListener('mouseup', this.boundDesignDocumentMouseUp);

    }



    componentWillUnmount() {

        if (this.boundDesignSelectionHandler) {

            document.removeEventListener('selectionchange', this.boundDesignSelectionHandler);

        }

        if (this.boundDesignDocumentMouseUp) {

            document.removeEventListener('mouseup', this.boundDesignDocumentMouseUp);

        }

    }



    componentDidUpdate(prevProps) {

        if (this.pendingHtmlCursor) {

            const { key, position, scrollTop, scrollLeft } = this.pendingHtmlCursor;

            const textarea = this.htmlEditorRefs[key];

            if (textarea) {

                textarea.setSelectionRange(position, position);

                textarea.scrollTop = scrollTop;

                textarea.scrollLeft = scrollLeft;

                if (this.lastFocusedHtmlEditorKey === key) {

                    textarea.focus({ preventScroll: true });

                }

                this.pendingHtmlCursor = null;

            }

        }

        if (this.pendingDesignEditorSync) {

            const { key, html } = this.pendingDesignEditorSync;

            const canvas = this.designEditorRefs[key];

            if (canvas) {

                canvas.innerHTML = html || '';

                this.designEditorSnapshot[key] = html || '';

                decorateDesignEditorCanvas(canvas);

                this.pendingDesignEditorSync = null;

            }

        }

        if (this.pendingDesignInsertFocus) {

            this.applyPendingDesignInsertFocus();

        }

        if (this.props.embedded) {

            if (this.props.productId !== prevProps.productId

                || this.props.productType !== prevProps.productType

                || this.props.displayName !== prevProps.displayName) {

                this.syncFromPropsAndLoad();

            }

        }

    }



    syncFromPropsAndLoad = () => {

        const { productType, productId, displayName } = this.props;

        this.setState({

            productType,

            productId: productId || '',

            displayName: displayName || ''

        }, () => {

            if (productId) this.loadProduct();

        });

    };



    getEditorMode = (scope, index) => normalizeEditorMode(this.state.tabEditorModes[editorKey(scope, index)]);



    setEditorMode = (scope, index, mode) => {

        const normalized = normalizeEditorMode(mode);

        this.setState((prev) => ({

            tabEditorModes: { ...prev.tabEditorModes, [editorKey(scope, index)]: normalized }

        }));

    };



    switchEditorMode = (scope, index, nextMode, currentMode, updateTab) => {

        const key = editorKey(scope, index);

        if (currentMode === 'design') {

            this.flushDesignEditorToState(key, index, updateTab);

        }

        delete this.designEditorSnapshot[key];

        this.setEditorMode(scope, index, nextMode);

    };



    flushDesignEditorToState = (key, index, updateTab) => {

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        stripDesignEditorClasses(canvas);

        canvas.querySelectorAll('[data-cst-block-id]').forEach((el) => {

            el.removeAttribute('data-cst-block-id');

        });

        const html = canvas.innerHTML;

        this.designEditorSnapshot[key] = html;

        updateTab(index, 'htmlContent', html);

        decorateDesignEditorCanvas(canvas);

    };



    syncDesignEditorToState = (key, index, updateTab) => {

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        const clone = canvas.cloneNode(true);

        stripDesignEditorArtifacts(clone);

        const html = clone.innerHTML;

        this.designEditorSnapshot[key] = html;

        updateTab(index, 'htmlContent', html);

    };



    attachDesignEditor = (element, key, htmlContent) => {

        if (!element) {

            delete this.designEditorRefs[key];

            return;

        }

        this.designEditorRefs[key] = element;

        const content = htmlContent || '';

        const dialogBlocksSync = () => {

            const media = this.state.designMediaDialog;

            if (media && editorKey(media.scope, media.index) === key) return true;

            const link = this.state.designLinkDialog;

            if (link && editorKey(link.scope, link.index) === key) return true;

            return false;

        };

        if (dialogBlocksSync()) {

            if (!element.querySelector('.cst-media-edit-overlay, .cst-section-edit-overlay')) {

                decorateDesignEditorCanvas(element);

            }

            return;

        }

        if (this.pendingDesignInsertFocus && this.pendingDesignInsertFocus.key === key && element.innerHTML.trim() !== '') {

            return;

        }

        const clone = element.cloneNode(true);

        stripDesignEditorArtifacts(clone);

        const liveCleanHtml = clone.innerHTML;

        if (liveCleanHtml === content) {

            this.designEditorSnapshot[key] = content;

            if (!element.querySelector('.cst-media-edit-overlay, .cst-section-edit-overlay')) {

                decorateDesignEditorCanvas(element);

            }

            return;

        }

        const snapshot = this.designEditorSnapshot[key];

        if (snapshot && liveCleanHtml === snapshot && liveCleanHtml !== content) {

            if (!element.querySelector('.cst-media-edit-overlay, .cst-section-edit-overlay')) {

                decorateDesignEditorCanvas(element);

            }

            return;

        }

        if (document.activeElement === element || element.contains(document.activeElement)) {

            if (element.innerHTML.trim() !== '') return;

        }

        element.innerHTML = content;

        this.designEditorSnapshot[key] = content;

        decorateDesignEditorCanvas(element);

    };



    saveDesignEditorSelection = (key, options = {}) => {

        const { syncFormatState = false } = options;

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        const selection = window.getSelection();

        if (!selection || selection.rangeCount === 0) return;

        const range = selection.getRangeAt(0);

        if (!canvas.contains(range.commonAncestorContainer)) return;

        this.designEditorSelection[key] = range.cloneRange();

        if (syncFormatState) {

            this.syncDesignFormatState(key);

        }

    };



    syncDesignFormatState = (key) => {

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        const next = getDesignFormatState(canvas);

        const prev = this.state.designFormatStateByEditor[key];

        if (prev

            && prev.bold === next.bold

            && prev.italic === next.italic

            && prev.underline === next.underline

            && prev.strikeThrough === next.strikeThrough

            && prev.textStyle === next.textStyle) {

            return;

        }

        this.setState((state) => ({

            designFormatStateByEditor: { ...state.designFormatStateByEditor, [key]: next }

        }));

    };



    restoreDesignEditorSelection = (key) => {

        const canvas = this.designEditorRefs[key];

        const range = this.designEditorSelection[key];

        if (!canvas || !range) return false;

        try {

            if (!canvas.contains(range.startContainer) || !canvas.contains(range.endContainer)) {

                return false;

            }

            const selection = window.getSelection();

            selection.removeAllRanges();

            selection.addRange(range);

            return true;

        } catch (e) {

            return false;

        }

    };



    focusDesignEditorForCommand = (key) => {

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        const selection = window.getSelection();

        if (selection && selection.rangeCount > 0) {

            const range = selection.getRangeAt(0);

            if (canvas.contains(range.commonAncestorContainer)) {

                this.designEditorSelection[key] = range.cloneRange();

            }

        }

        canvas.focus();

        this.restoreDesignEditorSelection(key);

    };



    refreshDesignEditorDecorations = (key) => {

        const canvas = this.designEditorRefs[key];

        if (canvas) decorateDesignEditorCanvas(canvas);

    };



    applyDesignFormat = (scope, index, updateTab, command, value = null) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        this.focusDesignEditorForCommand(key);

        if (typeof document.execCommand === 'function') {

            document.execCommand(command, false, value);

        }

        this.syncDesignEditorToState(key, index, updateTab);

        this.saveDesignEditorSelection(key, { syncFormatState: true });

    };



    applyDesignIndent = (scope, index, updateTab, delta) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        this.focusDesignEditorForCommand(key);

        const blocks = getDesignSelectionBlocks(canvas);

        if (blocks.length === 0) return;

        blocks.forEach((block) => {

            if (isDesignLayoutBlockElement(block) || block.classList.contains('jx-tab-col')) return;

            const current = parseInt(block.style.marginLeft || '0', 10) || 0;

            const next = Math.max(0, Math.min(current + (delta * 24), 96));

            if (next === 0) block.style.removeProperty('margin-left');

            else block.style.marginLeft = `${next}px`;

        });

        this.flushDesignEditorToState(key, index, updateTab);

        this.saveDesignEditorSelection(key);

    };



    applyDesignBlockFormat = (scope, index, updateTab, tagName) => {

        this.applyDesignFormat(scope, index, updateTab, 'formatBlock', tagName);

    };



    applyDesignAlignment = (scope, index, updateTab, alignClass) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        this.focusDesignEditorForCommand(key);

        const blocks = getDesignSelectionBlocks(canvas);

        if (blocks.length === 0) {

            this.applyDesignFormat(scope, index, updateTab, 'justifyLeft');

            return;

        }

        blocks.forEach((block) => {

            QL_ALIGN_CLASSES.forEach((cls) => block.classList.remove(cls));

            block.removeAttribute('align');

            if (alignClass) block.classList.add(alignClass);

        });

        this.flushDesignEditorToState(key, index, updateTab);

        this.saveDesignEditorSelection(key);

    };



    applyDesignLink = (scope, index, updateTab) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        this.saveDesignEditorSelection(key);

        const range = this.designEditorSelection[key];

        const existingUrl = range ? getDesignLinkUrlFromRange(canvas, range) : '';

        this.setState({

            designLinkDialog: { scope, index, updateTab, value: existingUrl },

        });

    };



    closeDesignLinkDialog = () => {

        this.setState({ designLinkDialog: null });

    };



    performDesignEditorUnlink = (key, index, updateTab) => {

        const canvas = this.designEditorRefs[key];

        if (!canvas) return false;

        this.focusDesignEditorForCommand(key);

        if (typeof document.execCommand === 'function') {

            try {

                if (document.execCommand('unlink')) {

                    this.syncDesignEditorToState(key, index, updateTab);

                    this.saveDesignEditorSelection(key, { syncFormatState: true });

                    return true;

                }

            } catch (e) {

                /* ignore */

            }

        }

        const selection = window.getSelection();

        const range = (selection && selection.rangeCount > 0)

            ? selection.getRangeAt(0)

            : this.designEditorSelection[key];

        const links = findDesignLinksInRange(canvas, range);

        if (links.length === 0) return false;

        unwrapDesignLinks(links);

        this.syncDesignEditorToState(key, index, updateTab);

        this.saveDesignEditorSelection(key, { syncFormatState: true });

        return true;

    };



    applyDesignLinkDialog = () => {

        const dialog = this.state.designLinkDialog;

        if (!dialog) return;

        const { scope, index, updateTab } = dialog;

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        const url = (dialog.value || '').trim();

        if (!url) {

            this.performDesignEditorUnlink(key, index, updateTab);

            this.closeDesignLinkDialog();

            return;

        }

        this.focusDesignEditorForCommand(key);

        document.execCommand('createLink', false, url);

        this.closeDesignLinkDialog();

        this.syncDesignEditorToState(key, index, updateTab);

        this.saveDesignEditorSelection(key, { syncFormatState: true });

    };



    removeDesignLink = () => {

        const dialog = this.state.designLinkDialog;

        if (!dialog) return;

        const { scope, index, updateTab } = dialog;

        const key = editorKey(scope, index);

        this.performDesignEditorUnlink(key, index, updateTab);

        this.closeDesignLinkDialog();

    };



    applyDesignTextStyle = (scope, index, updateTab, styleId) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        const style = DESIGN_TEXT_STYLES.find((s) => s.id === styleId);

        if (!canvas || !style) return;

        this.focusDesignEditorForCommand(key);

        if (style.block) {

            document.execCommand('formatBlock', false, style.block);

        }

        const blocks = getDesignSelectionBlocks(canvas);

        if (blocks.length === 0 && canvas.childNodes.length === 0) {

            document.execCommand('insertHTML', false, `<${style.block || 'p'}>${style.sizeClass ? `<span class="${style.sizeClass}">&nbsp;</span>` : '&nbsp;'}</${style.block || 'p'}>`);

        }

        getDesignSelectionBlocks(canvas).forEach((block) => {

            QL_SIZE_CLASSES.forEach((cls) => block.classList.remove(cls));

            if (style.sizeClass) block.classList.add(style.sizeClass);

        });

        this.syncDesignEditorToState(key, index, updateTab);

        this.saveDesignEditorSelection(key, { syncFormatState: true });

    };



    applyDesignForeColor = (scope, index, updateTab, color) => {

        if (!color) return;

        this.applyDesignFormat(scope, index, updateTab, 'foreColor', color);

    };



    applyDesignUnlink = (scope, index, updateTab) => {

        this.applyDesignFormat(scope, index, updateTab, 'unlink');

    };



    applyDesignInsertHr = (scope, index, updateTab) => {

        this.applyDesignFormat(scope, index, updateTab, 'insertHorizontalRule');

    };



    applyDesignBlockquote = (scope, index, updateTab) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        this.focusDesignEditorForCommand(key);

        const blocks = getDesignSelectionBlocks(canvas);

        const blockquotes = new Set();

        blocks.forEach((block) => {

            const quote = block.tagName === 'BLOCKQUOTE' ? block : block.closest('blockquote');

            if (quote && canvas.contains(quote)) blockquotes.add(quote);

        });

        if (blockquotes.size > 0) {

            blockquotes.forEach((quote) => unwrapDesignBlockquote(quote));

        } else {

            document.execCommand('formatBlock', false, 'blockquote');

        }

        this.flushDesignEditorToState(key, index, updateTab);

        this.saveDesignEditorSelection(key);

    };



    applyDesignRemoveBlockquote = (scope, index, updateTab) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        this.focusDesignEditorForCommand(key);

        canvas.querySelectorAll('blockquote').forEach((quote) => {

            if (canvas.contains(quote)) unwrapDesignBlockquote(quote);

        });

        this.flushDesignEditorToState(key, index, updateTab);

        this.saveDesignEditorSelection(key);

    };



    applyDesignInlineCode = (scope, index, updateTab) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        canvas.focus();

        const selection = window.getSelection();

        if (selection && selection.rangeCount > 0 && !selection.isCollapsed) {

            const text = selection.toString();

            document.execCommand('insertHTML', false, `<code>${text.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</code>`);

        } else {

            document.execCommand('insertHTML', false, '<code>code</code>');

        }

        this.flushDesignEditorToState(key, index, updateTab);

    };



    openDesignToolbarMenu = (type, event, scope, index) => {

        const key = editorKey(scope, index);

        this.saveDesignEditorSelection(key, { syncFormatState: true });

        this.setState({ designToolbarMenu: { type, anchorEl: event.currentTarget, scope, index } });

    };



    closeDesignToolbarMenu = () => {

        this.setState({ designToolbarMenu: null });

    };



    handleDesignToolbarLayoutSnippet = (snippet) => {

        const menu = this.state.designToolbarMenu;

        if (!menu) return;

        const { scope, index } = menu;

        this.closeDesignToolbarMenu();

        const tabs = scope === 'product' ? this.state.tabs : this.state.editingTemplateTabs;

        const tab = tabs[index];

        const updateTab = scope === 'product'

            ? (i, field, value) => this.updateTab(i, field, value)

            : (i, field, value) => this.updateEditingTemplateTab(i, field, value);

        this.handleSnippetClick(scope, index, updateTab, tab, snippet);

    };



    runDesignToolbarAction = (scope, index, updateTab, action) => {

        this.closeDesignToolbarMenu();

        action(scope, index, updateTab);

    };



    isDesignToolbarMenuOpen = (scope, index, type) => {

        const menu = this.state.designToolbarMenu;

        return !!(menu && menu.type === type && menu.scope === scope && menu.index === index);

    };



    openDesignColorPicker = (event, scope, index) => {

        const key = editorKey(scope, index);

        this.saveDesignEditorSelection(key);

        const canvas = this.designEditorRefs[key];

        const customHex = getDesignSelectionForeColor(canvas);

        this.setState({

            designColorPicker: {

                scope,

                index,

                anchorEl: event.currentTarget,

                tab: 0,

                customHex,

                nativePickerOpen: false,

            },

        });

    };



    closeDesignColorPicker = () => {

        this.setState({ designColorPicker: null });

    };



    handleDesignColorPopoverClose = (event, reason) => {

        const picker = this.state.designColorPicker;

        if (!picker) return;

        if (picker.nativePickerOpen) return;

        if (picker.tab === 1 && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return;

        this.closeDesignColorPicker();

    };



    setDesignColorPickerTab = (scope, index, tab) => {

        const key = editorKey(scope, index);

        if (tab === 1) {

            this.focusDesignEditorForCommand(key);

        }

        this.setState((prev) => {

            if (!prev.designColorPicker) return null;

            if (prev.designColorPicker.scope !== scope || prev.designColorPicker.index !== index) {

                return { designColorPicker: prev.designColorPicker };

            }

            const canvas = this.designEditorRefs[key];

            const next = { ...prev.designColorPicker, tab };

            if (tab === 1) {

                next.customHex = getDesignSelectionForeColor(canvas);

            }

            return { designColorPicker: next };

        });

    };



    setDesignColorNativePickerOpen = (open) => {

        this.setState((prev) => {

            if (!prev.designColorPicker) return null;

            return {

                designColorPicker: { ...prev.designColorPicker, nativePickerOpen: open },

            };

        });

    };



    applyDesignColorValue = (scope, index, updateTab, color) => {

        const normalized = normalizeHexColor(color);

        if (!normalized) return;

        this.applyDesignForeColor(scope, index, updateTab, normalized);

        this.closeDesignColorPicker();

    };



    getDesignBlockById = (scope, index, blockId) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas || !blockId) return null;

        return findDesignBlockById(canvas, blockId);

    };



    handleDesignCanvasMouseDown = (event) => {

        const actionBtn = event.target.closest ? event.target.closest('[data-cst-action]') : null;

        if (actionBtn) {

            event.preventDefault();

            return;

        }

        clearDesignBlockHighlight(event.currentTarget);

    };



    captureDesignInsertFocus = (key, inserted, focusIndex = null) => {

        const canvas = this.designEditorRefs[key];

        if (!canvas || !inserted) return;

        let resolvedIndex = focusIndex;

        if (resolvedIndex === null || resolvedIndex < 0) {

            const topLevel = getCanvasChildForElement(canvas, inserted);

            resolvedIndex = topLevel ? [...canvas.children].indexOf(topLevel) : -1;

        }

        this.pendingDesignInsertFocus = { key, focusIndex: resolvedIndex };

        this.lastFocusedDesignEditorKey = key;

    };



    scheduleDesignInsertFocus = () => {

        if (!this.pendingDesignInsertFocus) return;

        window.requestAnimationFrame(() => {

            window.requestAnimationFrame(() => {

                this.applyPendingDesignInsertFocus();

            });

        });

    };



    applyPendingDesignInsertFocus = () => {

        const pending = this.pendingDesignInsertFocus;

        if (!pending) return;

        const canvas = this.designEditorRefs[pending.key];

        if (!canvas || !canvas.isConnected) {

            this.pendingDesignInsertFocus = null;

            return;

        }

        let blockEl = null;

        if (pending.focusIndex >= 0 && pending.focusIndex < canvas.children.length) {

            blockEl = canvas.children[pending.focusIndex];

        } else if (canvas.lastElementChild) {

            blockEl = canvas.lastElementChild;

        }

        if (!blockEl) {

            this.pendingDesignInsertFocus = null;

            return;

        }

        this.pendingDesignInsertFocus = null;

        this.lastFocusedDesignEditorKey = pending.key;

        highlightDesignInsertedBlock(canvas, blockEl);

        focusDesignEditableInCanvas(canvas, blockEl);

        this.saveDesignEditorSelection(pending.key, { syncFormatState: true });

    };



    focusDesignInsertedSection = (key, inserted) => {

        this.captureDesignInsertFocus(key, inserted);

        this.scheduleDesignInsertFocus();

    };



    handleDesignCanvasClick = (event, key, scope, index, updateTab) => {

        const actionBtn = event.target.closest ? event.target.closest('[data-cst-action]') : null;

        if (actionBtn) {

            event.preventDefault();

            event.stopPropagation();

            this.handleDesignInlineAction(actionBtn, event, event.currentTarget, scope, index, updateTab);

        }

    };



    setDesignMediaEditTarget = (scope, index, element) => {

        this.designMediaEditTarget = {

            editorKey: editorKey(scope, index),

            element,

        };

    };



    handleDesignInlineAction = (actionBtn, clickEvent, canvas, scope, index, updateTab) => {

        const action = actionBtn.getAttribute('data-cst-action');

        const editorKeyValue = editorKey(scope, index);

        const sectionBlock = actionBtn.closest('.cst-layout-section-wrap');

        const blockId = sectionBlock ? ensureDesignBlockId(sectionBlock) : null;



        if (action === 'edit-video') {

            const videoEl = actionBtn.closest('.jx-tab-video');

            if (!videoEl) return;

            const iframe = videoEl.querySelector('iframe');

            const currentUrl = iframe ? iframeSrcToYoutubeInput(iframe.getAttribute('src')) : '';

            const editId = `cst-v-${Date.now()}`;

            videoEl.setAttribute('data-cst-media-ref', editId);

            this.setDesignMediaEditTarget(scope, index, videoEl);

            this.setState({

                designMediaDialog: {

                    scope,

                    index,

                    updateTab,

                    mediaType: 'video',

                    mode: 'edit',

                    value: currentUrl,

                    editId,

                },

            });

            return;

        }



        if (action === 'edit-image') {

            const imgWrap = actionBtn.closest('.cst-img-edit-wrap');

            const img = imgWrap

                ? imgWrap.querySelector('img')

                : (actionBtn.closest('img') || (sectionBlock && sectionBlock.querySelector('img')));

            if (!img) return;

            const editId = `cst-i-${Date.now()}`;

            img.setAttribute('data-cst-media-ref', editId);

            this.setDesignMediaEditTarget(scope, index, img);

            this.setState({

                designMediaDialog: {

                    scope,

                    index,

                    updateTab,

                    mediaType: 'image',

                    mode: 'edit',

                    value: img.getAttribute('src') || '',

                    editId,

                },

            });

            return;

        }



        if (action === 'section-add-before' || action === 'section-add-after') {

            if (!blockId) return;

            this.openDesignBlockInsertMenu(

                scope,

                index,

                blockId,

                action === 'section-add-before' ? 'before' : 'after',

                actionBtn,

                clickEvent

            );

            return;

        }



        if (action === 'table-add-row' || action === 'table-remove-row' || action === 'table-add-column' || action === 'table-remove-column') {

            const table = resolveDesignTableElement(sectionBlock);

            if (!table) return;

            if (action === 'table-add-row') {

                addTableRow(table);

            } else if (action === 'table-add-column') {

                addTableColumn(table);

            } else if (action === 'table-remove-row') {

                if (!removeTableRow(table)) {

                    window.$alertError && window.$alertError('Tables must keep at least one row.');

                    return;

                }

            } else if (action === 'table-remove-column') {

                if (!removeTableColumn(table)) {

                    window.$alertError && window.$alertError('Tables must keep at least one column.');

                    return;

                }

            }

            this.flushDesignEditorToState(editorKeyValue, index, updateTab);

            return;

        }



        if (action === 'section-delete') {

            if (!blockId || !sectionBlock) return;

            this.requestDeleteDesignBlock(scope, index, blockId, getDesignLayoutBlockLabel(sectionBlock));

        }

    };



    openDesignMediaDialog = (scope, index, updateTab, mediaType, mode = 'insert', insertContext = null) => {

        const key = editorKey(scope, index);

        this.saveDesignEditorSelection(key);

        this.setState({

            designMediaDialog: {

                scope,

                index,

                updateTab,

                mediaType,

                mode,

                value: '',

                editId: null,

                insertContext: insertContext || null,

            },

        });

    };



    closeDesignMediaDialog = () => {

        this.designMediaEditTarget = null;

        const dialog = this.state.designMediaDialog;

        if (dialog && dialog.editId) {

            const key = editorKey(dialog.scope, dialog.index);

            const canvas = this.designEditorRefs[key];

            if (canvas) {

                canvas.querySelectorAll(`[data-cst-media-ref="${dialog.editId}"]`).forEach((el) => {

                    el.removeAttribute('data-cst-media-ref');

                });

            }

        }

        this.setState({ designMediaDialog: null });

    };



    updateDesignMediaDialogValue = (value) => {

        this.setState((prev) => {

            if (!prev.designMediaDialog) return null;

            return { designMediaDialog: { ...prev.designMediaDialog, value } };

        });

    };



    applyDesignMediaDialog = () => {

        const dialog = this.state.designMediaDialog;

        if (!dialog) return;

        const { scope, index, updateTab, mediaType, mode, value, editId } = dialog;

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];



        if (mediaType === 'video') {

            const embedUrl = toYoutubeEmbedUrl(value);

            if (!embedUrl) {

                window.$alertError && window.$alertError('Enter a valid YouTube URL or video ID (e.g. https://www.youtube.com/watch?v=...).');

                return;

            }



            if (mode === 'insert') {

                const html = `<div class="jx-tab-video"><iframe src="${embedUrl}" title="Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;

                this.insertDesignBlockAtSelection(scope, index, updateTab, html, dialog.insertContext);

                this.closeDesignMediaDialog();

                return;

            }



            if (canvas && editId) {

                let videoEl = canvas.querySelector(`[data-cst-media-ref="${editId}"]`);

                if (!videoEl && this.designMediaEditTarget && this.designMediaEditTarget.editorKey === key) {

                    videoEl = this.designMediaEditTarget.element;

                }

                if (videoEl && canvas.contains(videoEl)) {

                    let iframe = videoEl.querySelector('iframe');

                    if (!iframe) {

                        videoEl.innerHTML = `<iframe src="${embedUrl}" title="Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;

                    } else {

                        iframe.setAttribute('src', embedUrl);

                        iframe.setAttribute('title', 'Video');

                    }

                    videoEl.removeAttribute('data-cst-media-ref');

                    videoEl.classList.remove('cst-media-empty');

                    this.flushDesignEditorToState(key, index, updateTab);

                } else {

                    window.$alertError && window.$alertError('Could not find the video to update. Try again.');

                    return;

                }

            }

            this.closeDesignMediaDialog();

            return;

        }



        if (mediaType === 'image') {

            const url = (value || '').trim();

            if (!url || !/^https?:\/\//i.test(url)) {

                window.$alertError && window.$alertError('Enter a full image URL starting with https://');

                return;

            }



            if (mode === 'insert') {

                const html = `<img src="${url.replace(/"/g, '&quot;')}" alt="Product image" loading="lazy" />`;

                this.insertDesignBlockAtSelection(scope, index, updateTab, html, dialog.insertContext);

                this.closeDesignMediaDialog();

                return;

            }



            if (canvas && editId) {

                let img = canvas.querySelector(`[data-cst-media-ref="${editId}"]`);

                if (!img && this.designMediaEditTarget && this.designMediaEditTarget.editorKey === key) {

                    img = this.designMediaEditTarget.element;

                }

                if (img && canvas.contains(img)) {

                    img.setAttribute('src', url);

                    if (!img.getAttribute('alt')) {

                        img.setAttribute('alt', 'Product image');

                    }

                    img.removeAttribute('data-cst-media-ref');

                    this.flushDesignEditorToState(key, index, updateTab);

                } else {

                    window.$alertError && window.$alertError('Could not find the image to update. Try again.');

                    return;

                }

            }

            this.closeDesignMediaDialog();

        }

    };



    updateDesignLinkDialogValue = (value) => {

        this.setState((prev) => {

            if (!prev.designLinkDialog) return null;

            return { designLinkDialog: { ...prev.designLinkDialog, value } };

        });

    };



    handleDesignCanvasKeyDown = (event, key, scope, index, updateTab) => {

        const canvas = event.currentTarget;

        const selection = window.getSelection();

        if (!selection || selection.rangeCount === 0) return;

        if (event.key === 'Delete' || event.key === 'Backspace') {

            const range = selection.getRangeAt(0);

            if (shouldProtectDesignDeleteKey(canvas, range, event.key)) {

                event.preventDefault();

            }

            return;

        }

        if (event.key !== 'Enter' || event.shiftKey) return;

        const block = findInnermostLayoutBlock(selection.anchorNode, canvas);

        if (!block) return;

        const range = selection.getRangeAt(0);

        if (!range.collapsed) return;

        const afterRange = range.cloneRange();

        afterRange.selectNodeContents(block);

        afterRange.setStart(range.endContainer, range.endOffset);

        if (afterRange.toString().trim() !== '') return;

        event.preventDefault();

        const inserted = insertEmptyParagraphRelative(block, 'after');

        if (inserted) this.captureDesignInsertFocus(key, inserted);

        this.flushDesignEditorToState(key, index, updateTab);

        if (inserted) this.scheduleDesignInsertFocus();

    };



    insertParagraphNearBlock = (scope, index, updateTab, blockId, position) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        const block = this.getDesignBlockById(scope, index, blockId);

        if (!canvas || !block) return;

        const inserted = insertEmptyParagraphRelative(block, position);

        if (inserted) this.captureDesignInsertFocus(key, inserted);

        this.flushDesignEditorToState(key, index, updateTab);

        if (inserted) this.scheduleDesignInsertFocus();

    };



    openDesignBlockInsertMenu = (scope, index, blockId, position, anchorEl, clickEvent) => {

        const anchorPosition = getDesignMenuAnchorPosition(anchorEl, clickEvent);

        if (!anchorPosition) return;

        this.setState({

            designBlockInsert: { scope, index, blockId, position, anchorPosition },

        });

    };



    closeDesignBlockInsertMenu = () => {

        this.setState({ designBlockInsert: null });

    };



    insertLayoutNearBlock = (scope, index, updateTab, blockId, position, snippetHtml) => {

        if (position === 'append' || !blockId) {

            this.closeDesignBlockInsertMenu();

            this.appendLayoutToCanvas(scope, index, updateTab, snippetHtml);

            return;

        }

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        let block = this.getDesignBlockById(scope, index, blockId);

        if (!block && position === 'after') block = canvas.lastElementChild;

        if (!block && position === 'before') block = canvas.firstElementChild;

        if (!block) {

            this.appendLayoutToCanvas(scope, index, updateTab, snippetHtml);

            return;

        }

        const inserted = insertHtmlRelative(block, position, snippetHtml);

        this.closeDesignBlockInsertMenu();

        if (inserted) this.captureDesignInsertFocus(key, inserted);

        this.flushDesignEditorToState(key, index, updateTab);

        if (inserted) this.scheduleDesignInsertFocus();

    };



    appendLayoutToCanvas = (scope, index, updateTab, snippetHtml) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        let inserted = null;

        if (canvas.lastElementChild) {

            inserted = insertHtmlRelative(canvas.lastElementChild, 'after', snippetHtml);

        } else {

            canvas.innerHTML = snippetHtml;

            inserted = canvas.lastElementChild;

        }

        if (inserted) this.captureDesignInsertFocus(key, inserted);

        this.flushDesignEditorToState(key, index, updateTab);

        if (inserted) this.scheduleDesignInsertFocus();

    };



    requestDeleteDesignBlock = (scope, index, blockId, label) => {

        this.setState({

            designBlockDelete: { scope, index, blockId, label },

        });

    };



    cancelDeleteDesignBlock = () => {

        this.setState({ designBlockDelete: null });

    };



    getDesignEditorUpdateTab = (scope) => {

        if (scope === 'product-description') return this.updateProductDescription;

        if (scope === 'template-description') return this.updateTemplateDescription;

        if (scope === 'template') return this.updateEditingTemplateTab;

        return this.updateTab;

    };



    confirmDeleteDesignBlock = () => {

        const pending = this.state.designBlockDelete;

        if (!pending) return;

        const { scope, index, blockId } = pending;

        const updateTab = this.getDesignEditorUpdateTab(scope);

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        const block = this.getDesignBlockById(scope, index, blockId);

        if (canvas && block) {

            block.remove();

            stripDesignEditorClasses(canvas);

            this.flushDesignEditorToState(key, index, updateTab);

        }

        this.setState({ designBlockDelete: null });

    };



    handleDesignEditorInput = (key, index, updateTab) => {

        const canvas = this.designEditorRefs[key];

        if (!canvas) return;

        const clone = canvas.cloneNode(true);

        stripDesignEditorArtifacts(clone);

        const html = clone.innerHTML;

        this.designEditorSnapshot[key] = html;

        updateTab(index, 'htmlContent', html);

    };



    isPreviewOpen = (scope, index) => !!this.state.tabShowPreview[editorKey(scope, index)];



    togglePreview = (scope, index) => {

        const key = editorKey(scope, index);

        this.setState((prev) => ({

            tabShowPreview: { ...prev.tabShowPreview, [key]: !prev.tabShowPreview[key] }

        }));

    };



    loadTemplates = async () => {

        try {

            const res = await axios.get(`${apiBaseUrl}admin/customer-site-controls/tab-templates`);

            this.setState({ templates: Array.isArray(res.data) ? res.data : [] });

        } catch (e) {

            console.error(e);

            window.$alertError && window.$alertError('Failed to load tab templates');

        }

    };



    createTemplate = async (useDefaultStructure = false) => {

        const name = (this.state.newTemplateName || '').trim();

        if (!name) {

            window.$alertError && window.$alertError('Enter a template name.');

            return;

        }

        try {

            await axios.post(`${apiBaseUrl}admin/customer-site-controls/tab-templates`, {

                name,

                isActive: true,

                items: useDefaultStructure

                    ? DEFAULT_TEMPLATE_TABS

                    : [{ sortOrder: 0, tabKey: 'tab-1', title: 'Overview', htmlContent: '<p></p>', isVisible: true }]

            });

            this.setState({ newTemplateName: '' });

            await this.loadTemplates();

            window.$alertSuccess && window.$alertSuccess('Template created');

        } catch (e) {

            console.error(e);

            window.$alertError && window.$alertError('Failed to create template');

        }

    };



    startEditTemplate = (template) => {

        this.setState({

            editingTemplateId: template.id,

            editingTemplateName: template.name || '',

            editingTemplateActive: template.isActive !== false,

            editingTemplateTabs: normalizeTabs(template.items),

            editingTemplateDescriptionHtml: template.productDescriptionHtml || '',

            templateActiveTabIndex: 0

        });

    };



    cancelEditTemplate = () => {

        this.setState({

            editingTemplateId: null,

            editingTemplateName: '',

            editingTemplateTabs: [],

            editingTemplateDescriptionHtml: '',

            editingTemplateActive: true,

            templateActiveTabIndex: 0

        });

    };



    saveEditingTemplate = async () => {

        const { editingTemplateId, editingTemplateName, editingTemplateTabs, editingTemplateActive } = this.state;

        if (!editingTemplateId) return;

        const name = (editingTemplateName || '').trim();

        if (!name) {

            window.$alertError && window.$alertError('Template name is required.');

            return;

        }

        this.setState({ saving: true });

        try {

            const productDescriptionHtml = this.collectTemplateDescriptionForSave();

            await axios.put(`${apiBaseUrl}admin/customer-site-controls/tab-templates/${encodeURIComponent(editingTemplateId)}`, {

                name,

                isActive: editingTemplateActive,

                productDescriptionHtml,

                items: editingTemplateTabs

            });

            await this.loadTemplates();

            window.$alertSuccess && window.$alertSuccess('Template saved');

            this.cancelEditTemplate();

            this.setState({ saving: false });

        } catch (e) {

            console.error(e);

            window.$alertError && window.$alertError('Failed to save template');

            this.setState({ saving: false });

        }

    };



    updateEditingTemplateTab = (index, field, value) => {

        this.setState((prev) => {

            const editingTemplateTabs = [...prev.editingTemplateTabs];

            editingTemplateTabs[index] = { ...editingTemplateTabs[index], [field]: value };

            return { editingTemplateTabs };

        });

    };



    addEditingTemplateTab = () => {

        this.setState((prev) => ({

            editingTemplateTabs: [

                ...prev.editingTemplateTabs,

                {

                    tabKey: `tab-${Date.now()}`,

                    title: 'New tab',

                    htmlContent: '',

                    sortOrder: prev.editingTemplateTabs.length,

                    isVisible: true

                }

            ],

            templateActiveTabIndex: prev.editingTemplateTabs.length

        }));

    };



    removeEditingTemplateTab = (index) => {

        this.setState((prev) => {

            const editingTemplateTabs = prev.editingTemplateTabs.filter((_, i) => i !== index);

            let templateActiveTabIndex = prev.templateActiveTabIndex;

            if (templateActiveTabIndex >= editingTemplateTabs.length) {

                templateActiveTabIndex = Math.max(0, editingTemplateTabs.length - 1);

            }

            return { editingTemplateTabs, templateActiveTabIndex };

        });

    };



    moveTab = (tabsKey, activeKey, index, direction) => {

        this.setState((prev) => {

            const tabs = [...prev[tabsKey]];

            const target = index + direction;

            if (target < 0 || target >= tabs.length) return null;

            const tmp = tabs[index];

            tabs[index] = tabs[target];

            tabs[target] = tmp;

            const reordered = tabs.map((t, i) => ({ ...t, sortOrder: i }));

            return {

                [tabsKey]: reordered,

                [activeKey]: target

            };

        });

    };



    deleteTemplate = async (id) => {

        if (!window.confirm('Delete this template?')) return;

        try {

            await axios.delete(`${apiBaseUrl}admin/customer-site-controls/tab-templates/${encodeURIComponent(id)}`);

            if (this.state.editingTemplateId === id) this.cancelEditTemplate();

            await this.loadTemplates();

            window.$alertSuccess && window.$alertSuccess('Template deleted');

        } catch (e) {

            console.error(e);

            window.$alertError && window.$alertError('Failed to delete template');

        }

    };



    loadProduct = async () => {

        const { productType, productId } = this.state;

        const id = (productId || '').trim();

        if (!id) {

            if (!this.props.embedded) {

                window.$alertError && window.$alertError('Enter a product GUID.');

            }

            return;

        }

        this.setState({ loading: true });

        try {

            const res = await axios.get(

                `${apiBaseUrl}admin/customer-site-controls/products/${encodeURIComponent(productType)}/${encodeURIComponent(id)}`

            );

            const data = res.data || {};

            this.setState({

                displayName: data.displayName || this.props.displayName || '',

                isCustomerListed: productType === 'productlisting' ? true : !!data.isCustomerListed,

                productDescriptionHtml: data.productDescriptionHtml || '',

                tabs: normalizeTabs(data.tabs),

                loading: false,

                productActiveTabIndex: 0

            });

        } catch (e) {

            console.error(e);

            window.$alertError && window.$alertError('Failed to load product tabs');

            this.setState({ loading: false });

        }

    };



    persistListing = async (isCustomerListed) => {

        const { productType, productId } = this.state;

        const id = (productId || '').trim();

        if (!id) return;

        this.setState({ saving: true });

        try {

            await axios.put(

                `${apiBaseUrl}admin/customer-site-controls/products/${encodeURIComponent(productType)}/${encodeURIComponent(id)}/listing`,

                { isCustomerListed }

            );

            this.setState({ isCustomerListed, saving: false });

        } catch (e) {

            console.error(e);

            window.$alertError && window.$alertError('Failed to update listing');

            this.setState({ saving: false });

        }

    };



    ensureListedForSave = async () => {

        const { isCustomerListed, productType, productId } = this.state;

        if (isCustomerListed) return true;

        const id = (productId || '').trim();

        if (!id) return false;

        if (!this.props.embedded) return false;

        try {

            await axios.put(

                `${apiBaseUrl}admin/customer-site-controls/products/${encodeURIComponent(productType)}/${encodeURIComponent(id)}/listing`,

                { isCustomerListed: true }

            );

            this.setState({ isCustomerListed: true });

            return true;

        } catch (e) {

            console.error(e);

            window.$alertError && window.$alertError('Failed to enable customer listing');

            return false;

        }

    };



    collectProductDescriptionForSave = () => {

        let html = this.state.productDescriptionHtml || '';

        const key = editorKey('product-description', 0);

        const canvas = this.designEditorRefs[key];

        if (canvas && this.getEditorMode('product-description', 0) === 'design') {

            const clone = canvas.cloneNode(true);

            stripDesignEditorArtifacts(clone);

            html = clone.innerHTML;

            this.designEditorSnapshot[key] = html;

            if (html !== this.state.productDescriptionHtml) {

                this.setState({ productDescriptionHtml: html });

            }

        }

        return html;

    };



    collectProductTabsForSave = () => {

        let changed = false;

        const nextTabs = this.state.tabs.map((tab, index) => {

            const key = editorKey('product', index);

            const canvas = this.designEditorRefs[key];

            if (!canvas || this.getEditorMode('product', index) !== 'design') return tab;

            const clone = canvas.cloneNode(true);

            stripDesignEditorArtifacts(clone);

            const html = clone.innerHTML;

            this.designEditorSnapshot[key] = html;

            if (html === tab.htmlContent) return tab;

            changed = true;

            return { ...tab, htmlContent: html };

        });

        if (changed) this.setState({ tabs: nextTabs });

        return normalizeTabs(nextTabs);

    };



    openSaveTemplateDialog = () => {

        this.setState({ saveTemplateDialog: { name: '' } });

    };



    closeSaveTemplateDialog = () => {

        this.setState({ saveTemplateDialog: null });

    };



    updateSaveTemplateDialogName = (name) => {

        this.setState((prev) => {

            if (!prev.saveTemplateDialog) return null;

            return { saveTemplateDialog: { ...prev.saveTemplateDialog, name } };

        });

    };



    saveProductTabsAsTemplate = async () => {

        const dialog = this.state.saveTemplateDialog;

        if (!dialog) return;

        const name = (dialog.name || '').trim();

        if (!name) {

            window.$alertError && window.$alertError('Enter a template name.');

            return;

        }

        const items = this.collectProductTabsForSave();

        const productDescriptionHtml = this.collectProductDescriptionForSave();

        if (items.length === 0 && !(productDescriptionHtml || '').trim()) {

            window.$alertError && window.$alertError('Add at least one tab or product description before saving a template.');

            return;

        }

        this.setState({ saving: true });

        try {

            await axios.post(`${apiBaseUrl}admin/customer-site-controls/tab-templates`, {

                name,

                isActive: true,

                productDescriptionHtml,

                items

            });

            await this.loadTemplates();

            this.closeSaveTemplateDialog();

            window.$alertSuccess && window.$alertSuccess('Template saved');

            this.setState({ saving: false });

        } catch (e) {

            console.error(e);

            window.$alertError && window.$alertError('Failed to save template');

            this.setState({ saving: false });

        }

    };



    saveTabs = async () => {

        const { productType, productId, isCustomerListed } = this.state;

        const id = (productId || '').trim();

        if (!id) return;

        if (!isCustomerListed && productType !== 'productlisting') {

            const listed = await this.ensureListedForSave();

            if (!listed) {

                window.$alertError && window.$alertError('Enable customer listing before saving tabs.');

                return;

            }

        }

        this.setState({ saving: true });

        try {

            const tabs = this.collectProductTabsForSave();

            const productDescriptionHtml = this.collectProductDescriptionForSave();

            await axios.put(

                `${apiBaseUrl}admin/customer-site-controls/products/${encodeURIComponent(productType)}/${encodeURIComponent(id)}/tabs`,

                { tabs, productDescriptionHtml }

            );

            window.$alertSuccess && window.$alertSuccess('Tabs saved');

            this.setState({ saving: false });

        } catch (e) {

            console.error(e);

            const msg = (e.response && e.response.data) || e.message || 'Failed to save tabs';

            window.$alertError && window.$alertError(typeof msg === 'string' ? msg : 'Failed to save tabs');

            this.setState({ saving: false });

        }

    };



    applyTemplate = async () => {

        const { productType, productId, templateId, isCustomerListed } = this.state;

        const id = (productId || '').trim();

        if (!id || !templateId) return;

        if (!isCustomerListed && productType !== 'productlisting') {

            const listed = await this.ensureListedForSave();

            if (!listed) {

                window.$alertError && window.$alertError('Enable customer listing first.');

                return;

            }

        }

        this.setState({ saving: true });

        try {

            await axios.post(

                `${apiBaseUrl}admin/customer-site-controls/products/${encodeURIComponent(productType)}/${encodeURIComponent(id)}/apply-template/${encodeURIComponent(templateId)}`

            );

            await this.loadProduct();

            window.$alertSuccess && window.$alertSuccess('Template applied');

            this.setState({ saving: false });

        } catch (e) {

            console.error(e);

            window.$alertError && window.$alertError('Failed to apply template');

            this.setState({ saving: false });

        }

    };



    updateTab = (index, field, value) => {

        this.setState((prev) => {

            const tabs = [...prev.tabs];

            tabs[index] = { ...tabs[index], [field]: value };

            return { tabs };

        });

    };



    addTab = () => {

        this.setState((prev) => ({

            tabs: [

                ...prev.tabs,

                {

                    tabKey: `tab-${Date.now()}`,

                    title: 'New tab',

                    htmlContent: '',

                    sortOrder: prev.tabs.length,

                    isVisible: true

                }

            ],

            productActiveTabIndex: prev.tabs.length

        }));

    };



    removeTab = (index) => {

        this.setState((prev) => {

            const tabs = prev.tabs.filter((_, i) => i !== index);

            let productActiveTabIndex = prev.productActiveTabIndex;

            if (productActiveTabIndex >= tabs.length) {

                productActiveTabIndex = Math.max(0, tabs.length - 1);

            }

            return { tabs, productActiveTabIndex };

        });

    };



    insertDesignBlockAtSelection = (scope, index, updateTab, snippetHtml, insertContext = null) => {

        const key = editorKey(scope, index);

        const canvas = this.designEditorRefs[key];

        if (!canvas) return false;

        this.focusDesignEditorForCommand(key);

        const selection = window.getSelection();

        let range = (selection && selection.rangeCount > 0) ? selection.getRangeAt(0) : null;

        if (!range && this.designEditorSelection[key]) {

            try {

                range = this.designEditorSelection[key].cloneRange();

            } catch (e) {

                /* ignore */

            }

        }

        let inserted = null;

        if (range && isDesignBlockInsertHtml(snippetHtml)) {

            const col = findParentColumn(range.startContainer, canvas);

            if (col) {

                inserted = insertLayoutInColumn(col, snippetHtml, range);

            }

        }

        if (!inserted && insertContext && insertContext.blockId) {

            const block = this.getDesignBlockById(scope, index, insertContext.blockId);

            if (block && (insertContext.position === 'before' || insertContext.position === 'after')) {

                inserted = insertHtmlRelative(block, insertContext.position, snippetHtml);

            }

        }

        if (!inserted && range && isDesignBlockInsertHtml(snippetHtml)) {

            const canvasChild = getCanvasChildFromNode(canvas, range.startContainer);

            if (canvasChild) {

                inserted = insertHtmlRelative(canvasChild, 'after', snippetHtml);

            }

        }

        if (!inserted) {

            if (canvas.lastElementChild) {

                inserted = insertHtmlRelative(canvas.lastElementChild, 'after', snippetHtml);

            } else {

                canvas.innerHTML = snippetHtml;

                inserted = canvas.lastElementChild;

            }

        }

        if (inserted) this.captureDesignInsertFocus(key, inserted);

        this.flushDesignEditorToState(key, index, updateTab);

        if (inserted) this.scheduleDesignInsertFocus();

        return !!inserted;

    };



    insertHtmlIntoEditor = (scope, index, updateTab, currentHtml, snippetHtml) => {

        const key = editorKey(scope, index);

        const mode = this.getEditorMode(scope, index);

        const textarea = this.htmlEditorRefs[key];

        const text = currentHtml || '';



        if (mode === 'html' && textarea) {

            const start = textarea.selectionStart;

            const end = textarea.selectionEnd;

            const neverFocusedThisEditor = this.lastFocusedHtmlEditorKey !== key;

            const useAppend = neverFocusedThisEditor && text.length > 0 && start === 0 && end === 0;



            if (!useAppend) {

                const newContent = insertHtmlAtPosition(text, snippetHtml, start, end);

                const scrollTop = textarea.scrollTop;

                const scrollLeft = textarea.scrollLeft;

                updateTab(index, 'htmlContent', newContent);

                this.pendingHtmlCursor = {

                    key,

                    position: start + snippetHtml.length,

                    scrollTop,

                    scrollLeft

                };

                return;

            }

        }



        if (mode === 'design') {

            const canvas = this.designEditorRefs[key];

            if (canvas && this.lastFocusedDesignEditorKey === key && selectionIsInsideElement(canvas)) {

                if (isDesignBlockInsertHtml(snippetHtml)) {

                    this.insertDesignBlockAtSelection(scope, index, updateTab, snippetHtml);

                    return;

                }

                insertHtmlIntoContentEditable(canvas, snippetHtml);

                this.flushDesignEditorToState(key, index, updateTab);

                return;

            }

            this.appendLayoutToCanvas(scope, index, updateTab, snippetHtml);

            return;

        }

        updateTab(index, 'htmlContent', appendHtml(text, snippetHtml));

    };



    insertSnippet = (scope, index, updateTab, tab, snippetHtml) => {

        this.insertHtmlIntoEditor(scope, index, updateTab, tab.htmlContent, snippetHtml);

    };



    handleSnippetClick = (scope, index, updateTab, tab, snippet) => {

        if (snippet.action === 'video') {

            this.openDesignMediaDialog(scope, index, updateTab, 'video', 'insert');

            return;

        }

        if (snippet.action === 'image') {

            this.openDesignMediaDialog(scope, index, updateTab, 'image', 'insert');

            return;

        }

        this.insertSnippet(scope, index, updateTab, tab, snippet.html);

    };



    renderStorefrontPreview(allTabs, activeIndex, liveHtmlContent) {

        const activeTab = allTabs[activeIndex];

        const sortedTabs = [...allTabs].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

        const visibleTabs = sortedTabs.filter((t) => t.isVisible !== false);

        const isActiveTab = (t) => t === activeTab || (!!t.tabKey && !!activeTab?.tabKey && t.tabKey === activeTab.tabKey);



        return (

            <div className="cst-storefront-mock">

                {activeTab?.isVisible === false && (

                    <Typography variant="caption" className="cst-preview-hidden-note">

                        This tab is marked hidden — it will not appear on the customer site.

                    </Typography>

                )}

                <section className="product-detail-tabs-section" aria-label="Storefront preview">

                    <div className="product-tabs-nav">

                        {visibleTabs.length === 0 ? (

                            <span className="cst-preview-empty-nav">No visible tabs</span>

                        ) : visibleTabs.map((t, i) => (

                            <button

                                key={t.tabKey || `preview-tab-${i}`}

                                type="button"

                                className={`product-tab-btn${isActiveTab(t) ? ' is-active' : ''}`}

                                tabIndex={-1}

                            >

                                {(t.title || 'Details').toUpperCase()}

                            </button>

                        ))}

                    </div>

                    <div className="product-tab-panel">

                        <div

                            className="product-tab-html"

                            dangerouslySetInnerHTML={{

                                __html: liveHtmlContent || '<p style="opacity:0.55">Nothing to preview yet.</p>'

                            }}

                        />

                    </div>

                </section>

            </div>

        );

    }



    renderDesignToolbar(scope, index, updateTab) {

        const key = editorKey(scope, index);

        const formatState = this.state.designFormatStateByEditor[key] || {

            bold: false,

            italic: false,

            underline: false,

            strikeThrough: false,

            textStyle: 'p1'

        };

        const textStyle = formatState.textStyle || 'p1';

        const menu = this.state.designToolbarMenu;

        const prevent = (e) => e.preventDefault();

        const saveSelection = () => this.saveDesignEditorSelection(key);

        const formatMouseDown = (command, value = null) => (e) => {

            e.preventDefault();

            saveSelection();

            this.applyDesignFormat(scope, index, updateTab, command, value);

        };

        const menuAnchor = (type) => (this.isDesignToolbarMenuOpen(scope, index, type) ? menu.anchorEl : null);



        return (

            <>

                <div className="cst-design-toolbar">

                    <Tooltip title="Insert block">

                        <IconButton size="small" onMouseDown={prevent} onClick={(e) => this.openDesignToolbarMenu('layout', e, scope, index)}>

                            <AddIcon fontSize="small" />

                        </IconButton>

                    </Tooltip>



                    <FormControl variant="outlined" size="small" className="cst-design-style-select" onMouseDown={prevent}>

                        <Select

                            value={textStyle}

                            onOpen={saveSelection}

                            onChange={(e) => this.applyDesignTextStyle(scope, index, updateTab, e.target.value)}

                        >

                            {DESIGN_TEXT_STYLES.map((style) => (

                                <MenuItem key={style.id} value={style.id}>{style.label}</MenuItem>

                            ))}

                        </Select>

                    </FormControl>



                    <span className="cst-design-toolbar-divider" />



                    <Tooltip title="Bold"><IconButton size="small" className={formatState.bold ? 'is-active' : ''} onMouseDown={formatMouseDown('bold')}><FormatBoldIcon fontSize="small" /></IconButton></Tooltip>

                    <Tooltip title="Italic"><IconButton size="small" className={formatState.italic ? 'is-active' : ''} onMouseDown={formatMouseDown('italic')}><FormatItalicIcon fontSize="small" /></IconButton></Tooltip>

                    <Tooltip title="Underline"><IconButton size="small" className={formatState.underline ? 'is-active' : ''} onMouseDown={formatMouseDown('underline')}><FormatUnderlinedIcon fontSize="small" /></IconButton></Tooltip>

                    <Tooltip title="Strikethrough"><IconButton size="small" className={formatState.strikeThrough ? 'is-active' : ''} onMouseDown={formatMouseDown('strikeThrough')}><FormatStrikethroughIcon fontSize="small" /></IconButton></Tooltip>



                    <span className="cst-design-toolbar-divider" />



                    <Tooltip title="Link"><IconButton size="small" onMouseDown={prevent} onClick={() => this.applyDesignLink(scope, index, updateTab)}><LinkIcon fontSize="small" /></IconButton></Tooltip>

                    <Tooltip title="Alignment"><IconButton size="small" onMouseDown={prevent} onClick={(e) => this.openDesignToolbarMenu('align', e, scope, index)}><FormatAlignLeftIcon fontSize="small" /></IconButton></Tooltip>

                    <Tooltip title="Bulleted list"><IconButton size="small" onMouseDown={formatMouseDown('insertUnorderedList')}><FormatListBulletedIcon fontSize="small" /></IconButton></Tooltip>

                    <Tooltip title="Numbered list"><IconButton size="small" onMouseDown={formatMouseDown('insertOrderedList')}><FormatListNumberedIcon fontSize="small" /></IconButton></Tooltip>



                    <span className="cst-design-toolbar-divider" />



                    <Tooltip title="Text color"><IconButton size="small" onMouseDown={(e) => { e.preventDefault(); this.saveDesignEditorSelection(key); }} onClick={(e) => this.openDesignColorPicker(e, scope, index)}><TextFieldsIcon fontSize="small" /></IconButton></Tooltip>

                    <Tooltip title="More formatting"><IconButton size="small" onMouseDown={prevent} onClick={(e) => this.openDesignToolbarMenu('more', e, scope, index)}><MoreHorizIcon fontSize="small" /></IconButton></Tooltip>

                </div>



                {this.renderDesignToolbarMenus(scope, index, updateTab, menuAnchor)}

            </>

        );

    }



    renderDesignToolbarMenus(scope, index, updateTab, menuAnchor) {

        return (

            <>

                <Menu anchorEl={menuAnchor('layout')} open={this.isDesignToolbarMenuOpen(scope, index, 'layout')} onClose={this.closeDesignToolbarMenu} getContentAnchorEl={null} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}>

                    {LAYOUT_SNIPPETS.map((snippet) => (

                        <MenuItem key={snippet.id} onClick={() => this.handleDesignToolbarLayoutSnippet(snippet)}>{snippet.label}</MenuItem>

                    ))}

                </Menu>



                <Menu anchorEl={menuAnchor('align')} open={this.isDesignToolbarMenuOpen(scope, index, 'align')} onClose={this.closeDesignToolbarMenu} getContentAnchorEl={null} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignAlignment(s, i, u, null))}><FormatAlignLeftIcon fontSize="small" style={{ marginRight: 8 }} /> Align left</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignAlignment(s, i, u, 'ql-align-center'))}><FormatAlignCenterIcon fontSize="small" style={{ marginRight: 8 }} /> Align center</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignAlignment(s, i, u, 'ql-align-right'))}><FormatAlignRightIcon fontSize="small" style={{ marginRight: 8 }} /> Align right</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignAlignment(s, i, u, 'ql-align-justify'))}><FormatAlignJustifyIcon fontSize="small" style={{ marginRight: 8 }} /> Justify</MenuItem>

                </Menu>



                <Menu anchorEl={menuAnchor('more')} open={this.isDesignToolbarMenuOpen(scope, index, 'more')} onClose={this.closeDesignToolbarMenu} getContentAnchorEl={null} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignUnlink(s, i, u))}>Remove link</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignIndent(s, i, u, 1))}>Increase indent</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignIndent(s, i, u, -1))}>Decrease indent</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignBlockquote(s, i, u))}>Blockquote</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignRemoveBlockquote(s, i, u))}>Remove blockquote</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignInsertHr(s, i, u))}>Horizontal rule</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignInlineCode(s, i, u))}>Inline code</MenuItem>

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.applyDesignFormat(s, i, u, 'removeFormat'))}>Clear formatting</MenuItem>

                    <Divider />

                    <MenuItem onClick={() => this.runDesignToolbarAction(scope, index, updateTab, (s, i, u) => this.switchEditorMode(s, i, 'html', 'design', u))}>Switch to HTML</MenuItem>

                </Menu>

            </>

        );

    }



    renderDesignColorPopover(scope, index, updateTab) {

        const picker = this.state.designColorPicker;

        const open = !!(picker && picker.scope === scope && picker.index === index);



        return (

            <Popover

                open={open}

                anchorEl={open ? picker.anchorEl : null}

                onClose={this.handleDesignColorPopoverClose}

                disableBackdropClick={open && picker.tab === 1}

                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}

                transformOrigin={{ vertical: 'top', horizontal: 'left' }}

            >

                <div className="cst-color-popover">

                    <Tabs

                        value={open ? picker.tab : 0}

                        onChange={(_, tab) => this.setDesignColorPickerTab(scope, index, tab)}

                        indicatorColor="primary"

                        textColor="primary"

                        variant="standard"

                        className="cst-color-tabs"

                    >

                        <Tab label="Palette" className="cst-color-tab" />

                        <Tab label="Custom" className="cst-color-tab" />

                    </Tabs>



                    {(open && picker.tab === 0) && (

                        <div className="cst-color-palette">

                            {DESIGN_TEXT_COLORS.map((swatch) => (

                                <button

                                    key={swatch.value}

                                    type="button"

                                    className="cst-color-palette-btn"

                                    title={swatch.label}

                                    onClick={() => this.applyDesignColorValue(scope, index, updateTab, swatch.value)}

                                >

                                    <span className="cst-design-menu-swatch" style={{ backgroundColor: swatch.value }} />

                                    <span>{swatch.label}</span>

                                </button>

                            ))}

                        </div>

                    )}



                    {(open && picker.tab === 1) && (

                        <div className="cst-color-custom">

                            <input

                                type="color"

                                className="cst-color-native-input"

                                value={normalizeHexColor(picker.customHex) || '#ffffff'}

                                onFocus={() => this.setDesignColorNativePickerOpen(true)}

                                onBlur={() => {

                                    window.setTimeout(() => this.setDesignColorNativePickerOpen(false), 250);

                                }}

                                onChange={(e) => this.setState({ designColorPicker: { ...picker, customHex: e.target.value } })}

                            />

                            <TextField

                                label="Hex"

                                size="small"

                                variant="outlined"

                                value={picker.customHex}

                                onChange={(e) => this.setState({ designColorPicker: { ...picker, customHex: e.target.value } })}

                                placeholder="#ffffff"

                                className="cst-color-hex-field"

                            />

                            <div className="cst-color-custom-actions">

                                <Button

                                    size="small"

                                    onClick={this.closeDesignColorPicker}

                                >

                                    Cancel

                                </Button>

                                <Button

                                    size="small"

                                    color="primary"

                                    variant="contained"

                                    onClick={() => this.applyDesignColorValue(scope, index, updateTab, picker.customHex)}

                                >

                                    Apply

                                </Button>

                            </div>

                        </div>

                    )}

                </div>

            </Popover>

        );

    }



    renderDesignMediaDialog() {

        const dialog = this.state.designMediaDialog;

        if (!dialog) return null;

        const isVideo = dialog.mediaType === 'video';

        const isInsert = dialog.mode === 'insert';

        const title = isInsert

            ? (isVideo ? 'Add a YouTube video' : 'Add an image')

            : (isVideo ? 'Edit video URL' : 'Edit image URL');

        const applyLabel = isInsert ? (isVideo ? 'Insert video' : 'Insert image') : (isVideo ? 'Update video' : 'Update image');



        return (

            <Dialog open onClose={() => this.closeDesignMediaDialog()} maxWidth="sm" fullWidth>

                <DialogTitle>{title}</DialogTitle>

                <DialogContent>

                    <Typography variant="body2" style={{ marginBottom: 12, color: '#555' }}>

                        {isVideo

                            ? (isInsert

                                ? 'Paste any YouTube link from your browser. To change a video later, hover the video in the editor and click Edit Video URL.'

                                : 'Paste a new YouTube link or video ID. Watch, share, and embed links all work.')

                            : (isInsert

                                ? 'Paste the full image URL. To change it later, hover the image in the editor and click Edit Image URL.'

                                : 'Enter the full web address for the image (must start with https://).')}

                    </Typography>

                    <TextField

                        autoFocus

                        fullWidth

                        variant="outlined"

                        label={isVideo ? 'YouTube URL or video ID' : 'Image URL'}

                        value={dialog.value || ''}

                        onChange={(e) => this.updateDesignMediaDialogValue(e.target.value)}

                        placeholder={isVideo ? 'https://www.youtube.com/watch?v=...' : 'https://example.com/your-image.jpg'}

                        margin="normal"

                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.applyDesignMediaDialog(); } }}

                    />

                </DialogContent>

                <DialogActions>

                    <Button onClick={() => this.closeDesignMediaDialog()}>Cancel</Button>

                    <Button onClick={() => this.applyDesignMediaDialog()} color="primary" variant="contained">{applyLabel}</Button>

                </DialogActions>

            </Dialog>

        );

    }



    renderSaveTemplateDialog() {

        const dialog = this.state.saveTemplateDialog;

        if (!dialog) return null;



        return (

            <Dialog open onClose={() => this.closeSaveTemplateDialog()} maxWidth="sm" fullWidth>

                <DialogTitle>Save tabs as template</DialogTitle>

                <DialogContent>

                    <Typography variant="body2" style={{ marginBottom: 12, color: '#555' }}>

                        Save the current product description, tab titles, and tab content as a reusable template.

                    </Typography>

                    <TextField

                        autoFocus

                        fullWidth

                        variant="outlined"

                        label="Template name"

                        value={dialog.name || ''}

                        onChange={(e) => this.updateSaveTemplateDialogName(e.target.value)}

                        placeholder="e.g. Standard product layout"

                        margin="normal"

                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.saveProductTabsAsTemplate(); } }}

                    />

                </DialogContent>

                <DialogActions>

                    <Button onClick={() => this.closeSaveTemplateDialog()}>Cancel</Button>

                    <Button onClick={() => this.saveProductTabsAsTemplate()} color="primary" variant="contained" disabled={this.state.saving}>

                        Save template

                    </Button>

                </DialogActions>

            </Dialog>

        );

    }



    renderDesignLinkDialog() {

        const dialog = this.state.designLinkDialog;

        if (!dialog) return null;



        return (

            <Dialog open onClose={() => this.closeDesignLinkDialog()} maxWidth="sm" fullWidth>

                <DialogTitle>{dialog.value ? 'Edit link' : 'Add link'}</DialogTitle>

                <DialogContent>

                    <Typography variant="body2" style={{ marginBottom: 12, color: '#555' }}>

                        Enter a web address for the selected text. Leave blank and click Remove link to unlink.

                    </Typography>

                    <TextField

                        autoFocus

                        fullWidth

                        variant="outlined"

                        label="Link URL"

                        value={dialog.value || ''}

                        onChange={(e) => this.updateDesignLinkDialogValue(e.target.value)}

                        placeholder="https://example.com"

                        margin="normal"

                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.applyDesignLinkDialog(); } }}

                    />

                </DialogContent>

                <DialogActions>

                    <Button onClick={() => this.closeDesignLinkDialog()}>Cancel</Button>

                    {dialog.value ? (

                        <Button onClick={() => this.removeDesignLink()}>Remove link</Button>

                    ) : null}

                    <Button onClick={() => this.applyDesignLinkDialog()} color="primary" variant="contained">Apply</Button>

                </DialogActions>

            </Dialog>

        );

    }



    renderDesignBlockInsertMenu() {

        const menu = this.state.designBlockInsert;

        if (!menu) return null;

        const updateTab = menu.scope === 'product'

            ? (index, field, value) => this.updateTab(index, field, value)

            : (index, field, value) => this.updateEditingTemplateTab(index, field, value);

        const { scope, index } = menu;



        return (

            <Menu

                anchorReference="anchorPosition"

                anchorPosition={menu.anchorPosition}

                open

                onClose={this.closeDesignBlockInsertMenu}

                getContentAnchorEl={null}

                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}

                transformOrigin={{ vertical: 'top', horizontal: 'left' }}

            >

                {LAYOUT_SNIPPETS.map((snippet) => (

                    <MenuItem

                        key={snippet.id}

                        onClick={() => {

                            if (snippet.action === 'video' || snippet.action === 'image') {

                                const menu = this.state.designBlockInsert;

                                this.closeDesignBlockInsertMenu();

                                this.openDesignMediaDialog(scope, index, updateTab, snippet.action, 'insert', menu ? {

                                    blockId: menu.blockId,

                                    position: menu.position,

                                } : null);

                                return;

                            }

                            this.insertLayoutNearBlock(scope, index, updateTab, menu.blockId, menu.position, snippet.html);

                        }}

                    >

                        {snippet.label}

                    </MenuItem>

                ))}

            </Menu>

        );

    }



    renderDesignBlockDeleteDialog() {

        const pending = this.state.designBlockDelete;

        if (!pending) return null;



        return (

            <Dialog open onClose={this.cancelDeleteDesignBlock} maxWidth="xs" fullWidth>

                <DialogTitle>Remove section?</DialogTitle>

                <DialogContent>

                    <Typography variant="body2">

                        Delete the <strong>{pending.label}</strong> section and all of its content? This cannot be undone.

                    </Typography>

                </DialogContent>

                <DialogActions>

                    <Button onClick={this.cancelDeleteDesignBlock}>Cancel</Button>

                    <Button color="secondary" variant="contained" onClick={this.confirmDeleteDesignBlock}>

                        Delete section

                    </Button>

                </DialogActions>

            </Dialog>

        );

    }



    renderDesignEditor(scope, index, tab, updateTab) {

        const key = editorKey(scope, index);

        return (

            <div className="cst-design-editor cst-storefront-mock">

                <div className="cst-design-toolbar-wrap">

                    {this.renderDesignToolbar(scope, index, updateTab)}

                    {this.renderDesignColorPopover(scope, index, updateTab)}

                </div>

                <div className="cst-design-stage-scroll">

                    <div className="product-tab-panel cst-design-panel">

                        <div

                            ref={(el) => this.attachDesignEditor(el, key, tab.htmlContent)}

                            className="product-tab-html cst-design-canvas"

                            contentEditable

                            suppressContentEditableWarning

                            role="textbox"

                            aria-multiline="true"

                            aria-label="Tab content design editor"

                            onInput={() => this.handleDesignEditorInput(key, index, updateTab)}

                            onMouseUp={() => this.saveDesignEditorSelection(key, { syncFormatState: true })}

                            onKeyUp={() => this.saveDesignEditorSelection(key, { syncFormatState: true })}

                            onSelect={() => this.saveDesignEditorSelection(key, { syncFormatState: true })}

                            onMouseDown={(e) => this.handleDesignCanvasMouseDown(e)}

                            onClick={(e) => this.handleDesignCanvasClick(e, key, scope, index, updateTab)}

                            onKeyDown={(e) => this.handleDesignCanvasKeyDown(e, key, scope, index, updateTab)}

                            onFocus={() => {

                                this.lastFocusedDesignEditorKey = key;

                                this.syncDesignFormatState(key);

                            }}

                        />

                        <div className="cst-canvas-insert-row">

                            <Button

                                size="small"

                                variant="outlined"

                                className="cst-canvas-insert-btn"

                                onMouseDown={(e) => e.preventDefault()}

                                onClick={(e) => {

                                    const canvas = this.designEditorRefs[key];

                                    if (!canvas || canvas.children.length === 0) {

                                        this.openDesignBlockInsertMenu(scope, index, null, 'append', e.currentTarget, e);

                                        return;

                                    }

                                    ensureDesignBlockId(canvas.lastElementChild);

                                    this.openDesignBlockInsertMenu(

                                        scope,

                                        index,

                                        canvas.lastElementChild.getAttribute('data-cst-block-id'),

                                        'after',

                                        e.currentTarget,

                                        e

                                    );

                                }}

                            >

                                + Add section at end

                            </Button>

                        </div>

                    </div>

                </div>

            </div>

        );

    }



    collectTemplateDescriptionForSave = () => {

        let html = this.state.editingTemplateDescriptionHtml || '';

        const key = editorKey('template-description', 0);

        const canvas = this.designEditorRefs[key];

        if (canvas && this.getEditorMode('template-description', 0) === 'design') {

            const clone = canvas.cloneNode(true);

            stripDesignEditorArtifacts(clone);

            html = clone.innerHTML;

            this.designEditorSnapshot[key] = html;

            if (html !== this.state.editingTemplateDescriptionHtml) {

                this.setState({ editingTemplateDescriptionHtml: html });

            }

        }

        return html;

    };



    updateTemplateDescription = (index, field, value) => {

        if (field === 'htmlContent') {

            this.setState({ editingTemplateDescriptionHtml: value });

        }

    };



    getTemplateDescriptionTab = () => ({

        tabKey: 'product-description',

        title: 'Product Description',

        htmlContent: this.state.editingTemplateDescriptionHtml || '',

        sortOrder: 0,

        isVisible: true

    });



    updateProductDescription = (index, field, value) => {

        if (field === 'htmlContent') {

            this.setState({ productDescriptionHtml: value });

        }

    };



    getProductDescriptionTab = () => ({

        tabKey: 'product-description',

        title: 'Product Description',

        htmlContent: this.state.productDescriptionHtml || '',

        sortOrder: 0,

        isVisible: true

    });



    renderTabContentEditor(scope, tab, index, updateTab, removeTab, tabsLength, allTabs, compact = false) {

        const embedded = this.props.embedded;

        const mode = this.getEditorMode(scope, index);

        const showHtmlPreview = mode === 'html';



        return (

            <Paper className={`cst-tab-editor${embedded ? ' cst-tab-editor-embedded' : ''}`} elevation={0}>

                <div className="cst-tab-editor-header">

                    {!compact && (

                    <TextField

                        placeholder="Tab title"

                        variant="outlined"

                        size="small"

                        value={tab.title}

                        onChange={(e) => updateTab(index, 'title', e.target.value)}

                        className="cst-tab-title-field"

                    />

                    )}

                    {!compact && !embedded && (

                        <TextField

                            label="Order"

                            type="number"

                            variant="outlined"

                            size="small"

                            value={tab.sortOrder}

                            onChange={(e) => updateTab(index, 'sortOrder', parseInt(e.target.value, 10) || 0)}

                            className="cst-tab-order-field"

                        />

                    )}

                    {!compact && (

                    <FormControlLabel

                        className="cst-tab-visible-toggle"

                        control={

                            <Checkbox

                                checked={!!tab.isVisible}

                                onChange={(e) => updateTab(index, 'isVisible', e.target.checked)}

                                color="primary"

                                size="small"

                            />

                        }

                        label="Visible"

                    />

                    )}

                    <div className="cst-mode-segment">

                        <button

                            type="button"

                            className={mode === 'design' ? 'is-active' : ''}

                            onClick={() => this.switchEditorMode(scope, index, 'design', mode, updateTab)}

                        >

                            Visual

                        </button>

                        <button

                            type="button"

                            className={mode === 'html' ? 'is-active' : ''}

                            onClick={() => this.switchEditorMode(scope, index, 'html', mode, updateTab)}

                        >

                            HTML

                        </button>

                    </div>

                    {!compact && (

                    <div className="cst-tab-editor-actions">

                        <Tooltip title="Move up">

                            <span>

                                <IconButton size="small" disabled={index === 0} onClick={() => this.moveTab(

                                    scope === 'product' ? 'tabs' : 'editingTemplateTabs',

                                    scope === 'product' ? 'productActiveTabIndex' : 'templateActiveTabIndex',

                                    index,

                                    -1

                                )}>

                                    <ArrowUpIcon fontSize="small" />

                                </IconButton>

                            </span>

                        </Tooltip>

                        <Tooltip title="Move down">

                            <span>

                                <IconButton size="small" disabled={index >= tabsLength - 1} onClick={() => this.moveTab(

                                    scope === 'product' ? 'tabs' : 'editingTemplateTabs',

                                    scope === 'product' ? 'productActiveTabIndex' : 'templateActiveTabIndex',

                                    index,

                                    1

                                )}>

                                    <ArrowDownIcon fontSize="small" />

                                </IconButton>

                            </span>

                        </Tooltip>

                        <Tooltip title="Remove tab">

                            <IconButton size="small" onClick={() => removeTab(index)}>

                                <DeleteIcon fontSize="small" />

                            </IconButton>

                        </Tooltip>

                    </div>

                    )}

                </div>



                <div className="cst-editor-body">

                    <div className="cst-editor-pane">

                {mode === 'html' && (

                <div className="cst-snippet-bar cst-snippet-bar-compact">

                    {LAYOUT_SNIPPETS.map((snippet) => (

                        <Chip

                            key={snippet.id}

                            label={snippet.label}

                            size="small"

                            clickable

                            className="cst-snippet-chip"

                            onClick={() => this.handleSnippetClick(scope, index, updateTab, tab, snippet)}

                        />

                    ))}

                </div>

                )}



                {mode === 'design' ? (

                    this.renderDesignEditor(scope, index, tab, updateTab)

                ) : (

                    <>

                    <textarea

                        className="cst-html-textarea"

                        ref={(el) => { this.htmlEditorRefs[editorKey(scope, index)] = el; }}

                        value={tab.htmlContent || ''}

                        onChange={(e) => updateTab(index, 'htmlContent', e.target.value)}

                        onFocus={() => { this.lastFocusedHtmlEditorKey = editorKey(scope, index); }}

                        placeholder={'<div class="jx-tab-cols jx-tab-cols-2">...</div>'}

                        spellCheck={false}

                        rows={18}

                    />

                    {showHtmlPreview && (

                        <div className="cst-html-preview-wrap">

                            <Typography variant="caption" className="cst-preview-label">

                                Storefront preview

                            </Typography>

                            {this.renderStorefrontPreview(allTabs || [], index, tab.htmlContent)}

                        </div>

                    )}

                    </>

                )}



                    </div>



                </div>

            </Paper>

        );

    }



    renderTabWorkspace(scope, tabs, activeIndex, setActiveIndex, updateTab, removeTab, addTab, keyPrefix) {

        if (!tabs.length) {

            return (

                <div className="cst-empty-tabs-wrap">

                    <Typography variant="body2" className="cst-empty-tabs">

                        No tabs yet. Add a tab or apply a template to get started.

                    </Typography>

                    <Button variant="contained" color="primary" onClick={addTab}>

                        Add tab

                    </Button>

                </div>

            );

        }



        const safeIndex = Math.min(activeIndex, tabs.length - 1);

        const activeTab = tabs[safeIndex];



        return (

            <div className="cst-tab-workspace">

                <div className="cst-tab-selector">

                    {tabs.map((tab, index) => (

                        <button

                            key={`${keyPrefix}-${tab.tabKey || index}`}

                            type="button"

                            className={`cst-tab-pill${safeIndex === index ? ' is-active' : ''}${tab.isVisible === false ? ' is-hidden' : ''}`}

                            onClick={() => setActiveIndex(index)}

                        >

                            {tab.title || `Tab ${index + 1}`}

                        </button>

                    ))}

                    <Button size="small" variant="outlined" color="primary" className="cst-add-tab-btn" onClick={addTab}>

                        + Add tab

                    </Button>

                </div>



                {activeTab && this.renderTabContentEditor(scope, activeTab, safeIndex, updateTab, removeTab, tabs.length, tabs)}

            </div>

        );

    }



    renderTemplateManager() {

        const {

            templates,

            newTemplateName,

            editingTemplateId,

            editingTemplateName,

            editingTemplateTabs,

            editingTemplateActive,

            saving,

            templateActiveTabIndex

        } = this.state;



        return (

            <Paper className="cst-section" elevation={1}>

                <Typography variant="h6" className="cst-section-title">

                    Tab templates

                </Typography>

                <Typography variant="body2" className="cst-section-desc">

                    Reusable tab structures for storefront products. Create a template, edit its tabs, then apply when editing a product.

                </Typography>

                <div className="cst-toolbar-row">

                    <TextField

                        label="New template name"

                        variant="outlined"

                        size="small"

                        value={newTemplateName}

                        onChange={(e) => this.setState({ newTemplateName: e.target.value })}

                        className="cst-flex-field"

                    />

                    <Button variant="outlined" color="primary" onClick={() => this.createTemplate(false)}>

                        Create blank

                    </Button>

                    <Button variant="outlined" color="primary" onClick={() => this.createTemplate(true)}>

                        Create standard tabs

                    </Button>

                </div>

                {templates.length > 0 && (

                    <ul className="cst-template-list">

                        {templates.map((t) => (

                            <li key={t.id}>

                                <span>{t.name} ({t.items?.length || 0} tabs)</span>

                                <Button size="small" onClick={() => this.startEditTemplate(t)}>Edit</Button>

                                <Button size="small" onClick={() => this.deleteTemplate(t.id)}>Delete</Button>

                            </li>

                        ))}

                    </ul>

                )}



                {editingTemplateId && (

                    <Paper className="cst-template-editor" elevation={0}>

                        <Typography variant="subtitle1" className="cst-subsection-title">Edit template</Typography>

                        <div className="cst-toolbar-row">

                            <TextField

                                label="Template name"

                                variant="outlined"

                                size="small"

                                value={editingTemplateName}

                                onChange={(e) => this.setState({ editingTemplateName: e.target.value })}

                                className="cst-flex-field"

                            />

                            <FormControlLabel

                                control={

                                    <Checkbox

                                        checked={editingTemplateActive}

                                        onChange={(e) => this.setState({ editingTemplateActive: e.target.checked })}

                                        color="primary"

                                    />

                                }

                                label="Active"

                            />

                            <Button variant="contained" color="secondary" onClick={this.saveEditingTemplate} disabled={saving}>

                                Save template

                            </Button>

                            <Button onClick={this.cancelEditTemplate}>Cancel</Button>

                        </div>

                        <Paper className="cst-section cst-description-section" elevation={0}>

                            <Typography variant="subtitle2" className="cst-section-title">

                                Product description

                            </Typography>

                            <Typography variant="body2" className="cst-section-desc">

                                Included when this template is applied to a product.

                            </Typography>

                            {this.renderTabContentEditor(

                                'template-description',

                                this.getTemplateDescriptionTab(),

                                0,

                                this.updateTemplateDescription,

                                () => {},

                                1,

                                null,

                                true

                            )}

                        </Paper>

                        {this.renderTabWorkspace(

                            'template',

                            editingTemplateTabs,

                            templateActiveTabIndex,

                            (index) => this.setState({ templateActiveTabIndex: index }),

                            this.updateEditingTemplateTab,

                            this.removeEditingTemplateTab,

                            this.addEditingTemplateTab,

                            'template'

                        )}

                    </Paper>

                )}

            </Paper>

        );

    }



    renderProductTabsEditor() {

        const {

            productType,

            productId,

            loading,

            saving,

            displayName,

            isCustomerListed,

            tabs,

            templates,

            templateId,

            productActiveTabIndex

        } = this.state;

        const embedded = this.props.embedded;



        const hasProduct = embedded

            ? !!(this.props.productId || productId)

            : !!(displayName || productId);



        return (

            <div className="cst-product-editor">

                {!embedded && (

                    <>

                        <Typography variant="h6" className="cst-section-title">

                            Storefront product tabs

                        </Typography>

                        <Typography variant="body2" className="cst-section-desc">

                            Load an assembly, subassembly, or part by GUID. Enable customer listing before editing tabs (HTML is sanitized on save).

                        </Typography>

                        <div className="cst-toolbar-row">

                            <FormControl variant="outlined" size="small" className="cst-type-field">

                                <InputLabel id="cst-product-type">Type</InputLabel>

                                <Select

                                    labelId="cst-product-type"

                                    value={productType}

                                    label="Type"

                                    onChange={(e) => this.setState({ productType: e.target.value })}

                                >

                                    <MenuItem value="assembly">Assembly</MenuItem>

                                    <MenuItem value="subassembly">Subassembly</MenuItem>

                                    <MenuItem value="part">Part</MenuItem>

                                </Select>

                            </FormControl>

                            <TextField

                                label="Product Id (GUID)"

                                variant="outlined"

                                size="small"

                                value={productId}

                                onChange={(e) => this.setState({ productId: e.target.value })}

                                className="cst-flex-field"

                            />

                            <Button variant="contained" color="primary" onClick={this.loadProduct} disabled={loading}>

                                {loading ? <CircularProgress size={22} /> : 'Load'}

                            </Button>

                        </div>

                    </>

                )}



                {embedded && loading && (

                    <div className="cst-loading-row">

                        <CircularProgress size={22} />

                        <Typography variant="body2">Loading storefront tabs…</Typography>

                    </div>

                )}



                {hasProduct && !loading && (

                    <>

                        <div className={`cst-listing-bar${embedded ? ' cst-listing-bar-embedded' : ''}`}>

                            {!embedded && displayName && (

                                <Typography variant="subtitle1">{displayName}</Typography>

                            )}

                            {productType !== 'productlisting' && (
                            <FormControlLabel

                                control={

                                    <Checkbox

                                        checked={isCustomerListed}

                                        onChange={(e) => this.persistListing(e.target.checked)}

                                        disabled={saving}

                                        color="primary"

                                    />

                                }

                                label="Listed on customer site"

                            />
                            )}
                        </div>



                        <div className="cst-toolbar-row cst-product-actions">

                            <Button variant="outlined" color="primary" onClick={this.addTab}>

                                Add tab

                            </Button>

                            <FormControl variant="outlined" size="small" className="cst-template-field" disabled={!templates.length}>

                                <InputLabel id="cst-template">Apply template</InputLabel>

                                <Select

                                    labelId="cst-template"

                                    value={templateId}

                                    label="Apply template"

                                    onChange={(e) => this.setState({ templateId: e.target.value })}

                                >

                                    <MenuItem value="">

                                        <em>Select…</em>

                                    </MenuItem>

                                    {templates.map((t) => (

                                        <MenuItem key={t.id} value={t.id}>

                                            {t.name}

                                        </MenuItem>

                                    ))}

                                </Select>

                            </FormControl>

                            <Button variant="outlined" color="primary" onClick={this.applyTemplate} disabled={saving || !templateId}>

                                Apply template

                            </Button>

                            <Button variant="outlined" color="primary" onClick={this.openSaveTemplateDialog} disabled={saving || tabs.length === 0}>

                                Save as template

                            </Button>

                            <div className="cst-toolbar-spacer" />

                            <Button variant="contained" color="secondary" onClick={this.saveTabs} disabled={saving}>

                                {saving ? <CircularProgress size={20} color="inherit" /> : 'Save tabs'}

                            </Button>

                        </div>



                        <Paper className="cst-section cst-description-section" elevation={1}>

                            <Typography variant="h6" className="cst-section-title">

                                Product description

                            </Typography>

                            <Typography variant="body2" className="cst-section-desc">

                                Shown below the price on the storefront product page. Use bullet lists for feature highlights (like the Squarespace product page).

                            </Typography>

                            {this.renderTabContentEditor(

                                'product-description',

                                this.getProductDescriptionTab(),

                                0,

                                this.updateProductDescription,

                                () => {},

                                1,

                                null,

                                true

                            )}

                        </Paper>



                        {this.renderTabWorkspace(

                            'product',

                            tabs,

                            productActiveTabIndex,

                            (index) => this.setState({ productActiveTabIndex: index }),

                            this.updateTab,

                            this.removeTab,

                            this.addTab,

                            'product'

                        )}

                    </>

                )}

            </div>

        );

    }



    render() {

        const { embedded, showTemplateManager } = this.props;



        return (

            <div className={`cst-panel${embedded ? ' cst-panel-embedded' : ''}`}>

                {showTemplateManager && this.renderTemplateManager()}

                {showTemplateManager && !embedded && <Divider className="cst-section-divider" />}

                {this.renderProductTabsEditor()}



                {this.renderDesignMediaDialog()}

                {this.renderDesignLinkDialog()}

                {this.renderDesignBlockInsertMenu()}

                {this.renderDesignBlockDeleteDialog()}

                {this.renderSaveTemplateDialog()}



                <style>

                    {`

                    .cst-panel { margin-top: 0; }

                    .cst-panel-embedded .cst-product-editor { margin-top: 0; }

                    .cst-section { padding: 20px; margin-bottom: 20px; border-radius: 8px; }

                    .cst-section-title { margin: 0 0 6px; font-weight: 600; }
                    .cst-description-section { margin: 16px 0 20px; padding: 16px; }
                    .cst-description-section .cst-tab-editor { margin-top: 12px; }

                    .cst-section-desc { margin: 0 0 16px; color: #666; line-height: 1.5; }

                    .cst-subsection-title { margin: 0 0 12px; font-weight: 600; }

                    .cst-section-divider { margin: 8px 0 20px; }

                    .cst-toolbar-row { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; margin-bottom: 16px; }

                    .cst-toolbar-spacer { flex: 1 1 auto; min-width: 12px; }

                    .cst-flex-field { flex: 1 1 220px; min-width: 180px; }

                    .cst-type-field { min-width: 150px; }

                    .cst-template-field { min-width: 200px; }

                    .cst-product-actions { margin-bottom: 12px; }

                    .cst-listing-bar { padding: 14px 16px; margin-bottom: 16px; background: #f8f9fb; border: 1px solid #e3e8ef; border-radius: 8px; display: flex; flex-wrap: wrap; align-items: center; gap: 12px 20px; }

                    .cst-listing-bar-embedded { padding: 10px 0; margin-bottom: 12px; background: transparent; border: none; }

                    .cst-listing-hint { color: #666; flex: 1 1 220px; line-height: 1.4; }

                    .cst-loading-row { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }

                    .cst-muted-note { color: #888; }

                    .cst-empty-tabs-wrap { display: flex; flex-wrap: wrap; align-items: center; gap: 12px 16px; padding: 8px 0 4px; }

                    .cst-empty-tabs { color: #888; margin: 0; }

                    .cst-template-list { margin: 0 0 16px; padding-left: 20px; }

                    .cst-template-list li { margin-bottom: 6px; display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }

                    .cst-template-editor { padding: 16px; margin-top: 12px; background: #fafafa; border: 1px solid #e8e8e8; border-radius: 8px; }

                    .cst-tab-workspace { margin-top: 4px; }

                    .cst-tab-selector { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px solid #e8e8e8; }

                    .cst-tab-pill { border: 1px solid #cfd8e3; background: #fff; color: #334; border-radius: 999px; padding: 6px 14px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s ease; }

                    .cst-tab-pill:hover { border-color: #1976d2; color: #1976d2; }

                    .cst-tab-pill.is-active { background: #1976d2; border-color: #1976d2; color: #fff; }

                    .cst-tab-pill.is-hidden { opacity: 0.55; font-style: italic; }

                    .cst-add-tab-btn { margin-left: 4px; }

                    .cst-tab-editor { padding: 12px; border: 1px solid #e3e8ef; border-radius: 8px; background: #fff; overflow: visible; width: 100%; box-sizing: border-box; }

                    .cst-tab-editor-embedded { padding: 8px 0 0; border: none; background: transparent; }

                    .cst-tab-editor-header { display: flex; flex-wrap: wrap; gap: 8px 10px; align-items: center; margin-bottom: 10px; }

                    .cst-tab-title-field { flex: 1 1 180px; min-width: 140px; }

                    .cst-tab-order-field { width: 72px; }

                    .cst-tab-visible-toggle { margin: 0 !important; }

                    .cst-tab-visible-toggle .MuiFormControlLabel-label { font-size: 13px; }

                    .cst-mode-segment {

                        display: inline-flex;

                        border: 1px solid #cfd8e3;

                        border-radius: 999px;

                        overflow: hidden;

                        background: #f5f7fa;

                    }

                    .cst-mode-segment button {

                        border: none;

                        background: transparent;

                        padding: 5px 12px;

                        font-size: 12px;

                        font-weight: 600;

                        color: #556;

                        cursor: pointer;

                    }

                    .cst-mode-segment button.is-active {

                        background: #1976d2;

                        color: #fff;

                    }

                    .cst-tab-editor-actions { margin-left: auto; display: flex; align-items: center; gap: 0; }

                    .cst-editor-mode-bar { display: none; }

                    .cst-snippet-bar-compact {

                        display: flex;

                        flex-wrap: wrap;

                        gap: 6px;

                        margin-bottom: 8px;

                        padding: 0;

                        background: transparent;

                        border: none;

                    }

                    .cst-snippet-bar { display: none; }

                    .cst-snippet-label { color: #556; margin-right: 4px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }

                    .cst-snippet-chip { background: #fff !important; border: 1px solid #cfd8e3 !important; }

                    .cst-snippet-chip:hover { background: #e8f2ff !important; }

                    .cst-design-editor {

                        border: 1px solid #2a2a2a;

                        border-radius: 8px;

                        overflow: hidden;

                        width: 100%;

                        display: flex;

                        flex-direction: column;

                        max-height: calc(100vh - 360px);

                    }

                    .cst-panel-embedded .cst-design-editor {

                        max-height: calc(100vh - 280px);

                    }

                    .cst-design-toolbar-wrap {

                        flex-shrink: 0;

                        position: relative;

                        z-index: 12;

                        background: #fff;

                    }

                    .cst-design-stage-scroll {

                        flex: 1;

                        min-height: 0;

                        overflow-y: auto;

                        overflow-x: hidden;

                        background: #000;

                        -webkit-overflow-scrolling: touch;

                    }

                    .cst-design-stage {

                        background: #000;

                    }

                    .cst-design-toolbar {

                        display: flex;

                        flex-wrap: nowrap;

                        align-items: center;

                        gap: 1px;

                        padding: 6px 8px;

                        background: #fff;

                        border-bottom: 1px solid #e0e0e0;

                        overflow-x: auto;

                        overflow-y: hidden;

                        -webkit-overflow-scrolling: touch;

                    }

                    .cst-design-toolbar .MuiIconButton-root {

                        padding: 6px;

                    }

                    .cst-design-toolbar .MuiIconButton-root.is-active {

                        color: #1976d2;

                        background: rgba(25, 118, 210, 0.12);

                    }

                    .cst-design-style-select {

                        min-width: 118px;

                        margin: 0 2px;

                        flex: 0 0 auto;

                    }

                    .cst-design-style-select .MuiOutlinedInput-root {

                        height: 32px;

                    }

                    .cst-design-style-select .MuiSelect-select {

                        padding: 6px 10px;

                        font-size: 13px;

                    }

                    .cst-design-color-group { display: none; }

                    .cst-design-menu-swatch {

                        display: inline-block;

                        width: 14px;

                        height: 14px;

                        border-radius: 50%;

                        margin-right: 10px;

                        border: 1px solid rgba(0, 0, 0, 0.15);

                        vertical-align: middle;

                    }

                    .cst-design-html-btn { display: none; }

                    .cst-design-toolbar-divider {

                        width: 1px;

                        height: 22px;

                        margin: 0 4px;

                        background: #d5dde8;

                    }

                    .cst-design-hint {

                        display: none;

                    }

                    .cst-design-panel {

                        margin: 0;

                        min-height: 0;

                        background: #111;

                        color: #ccc;

                        position: relative;

                        max-width: 100%;

                        box-sizing: border-box;

                        overflow-x: auto;

                    }

                    .cst-design-canvas {

                        min-height: 120px;

                        outline: none;

                        cursor: text;

                        color: #ccc;

                        max-width: 100%;

                        box-sizing: border-box;

                        overflow-wrap: anywhere;

                        word-break: break-word;

                    }

                    .cst-design-canvas:focus {

                        box-shadow: none;

                    }

                    .cst-design-canvas p,

                    .cst-design-canvas li,

                    .cst-design-canvas blockquote,

                    .cst-design-canvas h1,

                    .cst-design-canvas h2,

                    .cst-design-canvas h3,

                    .cst-design-canvas h4,

                    .cst-design-canvas h5,

                    .cst-design-canvas h6,

                    .cst-design-canvas td,

                    .cst-design-canvas th {

                        color: inherit;

                        overflow-wrap: anywhere;

                        word-break: break-word;

                        max-width: 100%;

                    }

                    .cst-design-canvas code {

                        background: rgba(255, 255, 255, 0.08);

                        padding: 0.1em 0.35em;

                        border-radius: 3px;

                        font-family: Consolas, Monaco, 'Courier New', monospace;

                    }

                    .cst-html-preview-wrap {

                        margin-top: 16px;

                        padding-top: 14px;

                        border-top: 1px solid #e8e8e8;

                    }

                    .cst-design-editor .jx-tab-cols,

                    .cst-design-editor .jx-tab-callout,

                    .cst-design-editor .jx-tab-video,

                    .cst-design-editor .jx-tab-video-text .jx-tab-video,

                    .cst-design-editor .cst-table-edit-wrap,

                    .cst-design-editor hr.jx-tab-divider {

                        position: relative;

                        outline: 1px dashed rgba(0, 229, 255, 0.35);

                        outline-offset: 3px;

                        border-radius: 4px;

                        margin-top: 1.75rem;

                    }

                    .cst-design-editor .cst-table-edit-wrap > table.jx-tab-table {

                        width: 100%;

                        max-width: 100%;

                        margin-top: 0;

                        outline: none;

                        table-layout: fixed;

                    }

                    .cst-design-editor .cst-table-edit-wrap table th,

                    .cst-design-editor .cst-table-edit-wrap table td,

                    .cst-design-editor table.jx-tab-table th,

                    .cst-design-editor table.jx-tab-table td {

                        border: 1px solid rgba(255, 255, 255, 0.18);

                        padding: 0.45rem 0.6rem;

                        min-width: 0;

                        min-height: 2.25rem;

                        line-height: 1.5;

                        vertical-align: top;

                        box-sizing: border-box;

                        overflow-wrap: anywhere;

                        word-break: break-word;

                    }

                    .cst-design-editor .cst-table-edit-wrap table td:empty::before,

                    .cst-design-editor .cst-table-edit-wrap table th:empty::before,

                    .cst-design-editor table.jx-tab-table td:empty::before,

                    .cst-design-editor table.jx-tab-table th:empty::before {

                        content: '\\00a0';

                        display: inline-block;

                        min-height: 1.5em;

                    }

                    .cst-design-editor .cst-table-edit-wrap table th,

                    .cst-design-editor table.jx-tab-table th {

                        background: rgba(0, 229, 255, 0.12);

                        color: #fff;

                        font-weight: 600;

                    }

                    .cst-design-editor table td:focus,

                    .cst-design-editor table th:focus {

                        outline: none;

                    }

                    .cst-design-editor .jx-tab-col {

                        position: relative;

                        overflow: visible;

                        min-width: 0;

                        max-width: 100%;

                        overflow-wrap: anywhere;

                        word-break: break-word;

                    }

                    .cst-design-editor .jx-tab-col > .jx-tab-cols {

                        width: 100%;

                        margin-top: 0.5rem;

                    }

                    .cst-design-editor .jx-tab-cols {

                        display: grid;

                        gap: 1.25rem;

                        width: 100%;

                        max-width: 100%;

                        min-width: 0;

                    }

                    .cst-design-editor .jx-tab-cols-2 {

                        grid-template-columns: repeat(2, minmax(0, 1fr));

                    }

                    .cst-design-editor .jx-tab-cols-3 {

                        grid-template-columns: repeat(3, minmax(0, 1fr));

                    }

                    .cst-design-editor .jx-tab-col .cst-layout-section-wrap {

                        z-index: 2;

                    }

                    .cst-design-editor .jx-tab-col .cst-layout-section-wrap > .cst-section-edit-overlay {

                        z-index: 6;

                    }

                    .cst-design-editor .jx-tab-cols::before,

                    .cst-design-editor .jx-tab-callout::before,

                    .cst-design-editor .jx-tab-video::before,

                    .cst-design-editor .jx-tab-video-text .jx-tab-video::before,

                    .cst-design-editor .cst-table-edit-wrap::before {

                        position: absolute;

                        top: -1.35rem;

                        left: 0;

                        padding: 0.1rem 0.45rem;

                        font-size: 10px;

                        font-weight: 700;

                        letter-spacing: 0.06em;

                        text-transform: uppercase;

                        color: #003840;

                        background: #00e5ff;

                        border-radius: 3px;

                        z-index: 1;

                        pointer-events: none;

                    }

                    .cst-design-editor .jx-tab-cols::before { content: 'Columns'; }

                    .cst-design-editor .jx-tab-cols-2::before { content: '2 columns'; }

                    .cst-design-editor .jx-tab-cols-3::before { content: '3 columns'; }

                    .cst-design-editor .jx-tab-video-text::before { content: 'Video + text'; }

                    .cst-design-editor .jx-tab-img-text::before { content: 'Image + text'; }

                    .cst-design-editor .jx-tab-callout::before { content: 'Callout'; }

                    .cst-design-editor .cst-table-edit-wrap::before { content: 'Table'; }

                    .cst-design-editor .jx-tab-video::before,

                    .cst-design-editor .jx-tab-video-text .jx-tab-video::before { content: 'Video'; }

                    .cst-design-editor .jx-tab-video::after,

                    .cst-design-editor .jx-tab-video-text .jx-tab-video::after {

                        display: none;

                    }

                    .cst-design-editor .is-block-selected::before,

                    .cst-design-editor .is-block-selected::after {

                        display: none !important;

                    }

                    .cst-design-editor .is-block-selected {

                        box-shadow: 0 0 0 2px rgba(0, 229, 255, 0.65);

                        border-radius: 2px;

                    }

                    .cst-editable-media-wrap {

                        position: relative;

                        display: block;

                    }

                    .cst-design-editor .cst-img-edit-wrap {

                        display: inline-block;

                        max-width: 100%;

                    }

                    .cst-design-editor .cst-img-edit-wrap img {

                        display: block;

                        max-width: 100%;

                        height: auto;

                    }

                    .cst-media-edit-overlay {

                        position: absolute;

                        inset: 0;

                        display: flex;

                        align-items: center;

                        justify-content: center;

                        background: rgba(0, 0, 0, 0.62);

                        opacity: 0;

                        transition: opacity 0.15s ease;

                        z-index: 4;

                        pointer-events: none;

                        border-radius: 4px;

                    }

                    .cst-editable-media-wrap:hover .cst-media-edit-overlay,

                    .cst-media-empty .cst-media-edit-overlay {

                        opacity: 1;

                        pointer-events: auto;

                    }

                    .cst-inline-edit-btn {

                        border: none;

                        border-radius: 999px;

                        padding: 0.45rem 0.9rem;

                        font-size: 12px;

                        font-weight: 700;

                        letter-spacing: 0.02em;

                        color: #003840;

                        background: #00e5ff;

                        cursor: pointer;

                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);

                        pointer-events: auto;

                    }

                    .cst-inline-edit-btn:hover {

                        filter: brightness(1.05);

                    }

                    .cst-media-empty.jx-tab-video {

                        min-height: 180px;

                        background: rgba(255, 255, 255, 0.06);

                    }

                    .cst-media-empty.jx-tab-video iframe {

                        opacity: 0.15;

                    }

                    .cst-section-edit-overlay {

                        position: absolute;

                        top: -1.35rem;

                        right: 0;

                        display: flex;

                        flex-wrap: wrap;

                        gap: 4px;

                        justify-content: flex-end;

                        opacity: 0;

                        transition: opacity 0.15s ease;

                        z-index: 5;

                        pointer-events: none;

                        max-width: 100%;

                    }

                    .cst-layout-section-wrap:hover > .cst-section-edit-overlay {

                        opacity: 1;

                        pointer-events: auto;

                    }

                    .cst-layout-section-wrap:has(.cst-layout-section-wrap:hover) > .cst-section-edit-overlay {

                        opacity: 0;

                        pointer-events: none;

                    }

                    .cst-section-edit-overlay .cst-inline-edit-btn {

                        font-size: 10px;

                        padding: 0.2rem 0.45rem;

                        white-space: nowrap;

                    }

                    .cst-section-edit-overlay .cst-inline-edit-btn[data-cst-action="section-delete"] {

                        background: #ff5252;

                        color: #fff;

                    }

                    .cst-section-edit-overlay .cst-inline-edit-btn[data-cst-action="table-remove-row"],

                    .cst-section-edit-overlay .cst-inline-edit-btn[data-cst-action="table-remove-column"] {

                        background: rgba(255, 255, 255, 0.14);

                        color: #fff;

                        box-shadow: none;

                    }

                    .cst-block-toolbar {

                        display: none;

                    }

                    .cst-canvas-insert-row {

                        padding: 12px 14px;

                        border-top: 1px solid rgba(0, 229, 255, 0.22);

                        background: rgba(0, 229, 255, 0.06);

                        text-align: center;

                    }

                    .cst-canvas-insert-btn {

                        color: #00e5ff !important;

                        border-color: rgba(0, 229, 255, 0.55) !important;

                        background: rgba(0, 0, 0, 0.35) !important;

                        font-weight: 700 !important;

                        letter-spacing: 0.04em;

                        text-transform: uppercase;

                        font-size: 11px !important;

                    }

                    .cst-canvas-insert-btn:hover {

                        background: rgba(0, 229, 255, 0.14) !important;

                        border-color: #00e5ff !important;

                    }

                    .cst-color-popover {

                        width: 260px;

                        padding-bottom: 10px;

                        box-sizing: border-box;

                    }

                    .cst-color-tabs {

                        border-bottom: 1px solid #e0e0e0;

                    }

                    .cst-color-tabs .MuiTabs-scroller {

                        overflow: hidden !important;

                    }

                    .cst-color-tabs .MuiTabs-flexContainer {

                        justify-content: stretch;

                    }

                    .cst-color-tab {

                        min-width: 0 !important;

                        flex: 1 1 0;

                        max-width: none;

                        min-height: 36px;

                        padding: 6px 8px !important;

                        font-size: 12px;

                        text-transform: none;

                    }

                    .cst-color-palette {

                        display: grid;

                        grid-template-columns: 1fr 1fr;

                        gap: 6px;

                        padding: 10px 12px;

                    }

                    .cst-color-palette-btn {

                        display: flex;

                        align-items: center;

                        gap: 8px;

                        border: 1px solid #e0e0e0;

                        border-radius: 6px;

                        background: #fff;

                        padding: 6px 8px;

                        cursor: pointer;

                        font-size: 12px;

                    }

                    .cst-color-custom {

                        display: flex;

                        flex-direction: column;

                        gap: 10px;

                        padding: 12px;

                    }

                    .cst-color-native-input {

                        width: 100%;

                        height: 120px;

                        border: none;

                        padding: 0;

                        cursor: pointer;

                    }

                    .cst-color-hex-field { width: 100%; }

                    .cst-color-custom-actions {

                        display: flex;

                        justify-content: flex-end;

                        gap: 8px;

                        margin-top: 4px;

                    }

                    .cst-design-editor iframe {

                        pointer-events: none;

                    }

                    .cst-html-textarea {

                        display: block;

                        width: 100%;

                        min-height: 420px;

                        box-sizing: border-box;

                        padding: 12px 14px;

                        font-family: Consolas, Monaco, 'Courier New', monospace;

                        font-size: 13px;

                        line-height: 1.55;

                        border: 1px solid #cfd8e3;

                        border-radius: 6px;

                        background: #fafbfc;

                        color: #1a1a1a;

                        resize: vertical;

                    }

                    .cst-html-textarea:focus {

                        outline: none;

                        border-color: #1976d2;

                        box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.15);

                    }

                    .cst-preview-wrap { margin-top: 16px; padding-top: 14px; border-top: 1px solid #e8e8e8; }

                    .cst-editor-body { margin-top: 0; width: 100%; }

                    .cst-editor-body-stacked {

                        display: flex;

                        flex-direction: column;

                        gap: 20px;

                        width: 100%;

                    }

                    .cst-editor-pane { min-width: 0; width: 100%; }

                    .cst-preview-pane {

                        min-width: 0;

                        width: 100%;

                        position: static;

                    }

                    .cst-preview-label { display: block; margin-bottom: 8px; color: #666; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }

                    .cst-preview-hidden-note {

                        display: block;

                        padding: 8px 12px;

                        margin-bottom: 8px;

                        background: #fff3e0;

                        color: #e65100;

                        border-radius: 4px;

                        font-weight: 600;

                    }

                    .cst-preview-empty-nav {

                        display: block;

                        padding: 0.65rem 0.75rem;

                        color: rgba(255,255,255,0.45);

                        font-size: 0.85rem;

                    }

                    .cst-storefront-mock {

                        --text: #fff;

                        --text-muted: #ccc;

                        --accent: #00e5ff;

                        --bg-card: #111;

                        text-align: left;

                        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;

                        font-size: 16px;

                        line-height: 1.5;

                        -webkit-font-smoothing: antialiased;

                        -moz-osx-font-smoothing: grayscale;

                    }

                    .cst-storefront-mock .product-detail-tabs-section {

                        margin: 0;

                        border: 1px solid rgba(255, 255, 255, 0.12);

                        border-radius: 4px;

                        overflow: hidden;

                        background: var(--bg-card, #111);

                        width: 100%;

                    }

                    .cst-storefront-mock .product-tab-panel {

                        padding: 1.25rem 1rem;

                        color: var(--text-muted, #ccc);

                        line-height: 1.65;

                        overflow: visible;

                        text-align: left;

                    }

                    .cst-storefront-mock .product-tab-html {

                        text-align: left;

                        font-size: 1rem;

                        line-height: 1.65;

                        color: var(--text-muted, #ccc);

                        max-width: 100%;

                        overflow-wrap: anywhere;

                        word-break: break-word;

                    }

                    .cst-storefront-mock .product-tab-html .ql-size-small {

                        font-size: 0.75em;

                    }

                    .cst-storefront-mock .product-tab-html .ql-size-large {

                        font-size: 1.5em;

                    }

                    .cst-storefront-mock .product-tab-html .ql-size-huge {

                        font-size: 2.5em;

                    }

                    .cst-storefront-mock .product-tab-html h1 {

                        font-size: 2em;

                    }

                    .cst-storefront-mock .product-tab-html h2 {

                        font-size: 1.5em;

                    }

                    .cst-storefront-mock .product-tab-html h3 {

                        font-size: 1.17em;

                    }

                    .cst-storefront-mock .product-tab-html h4 {

                        font-size: 1em;

                    }

                    .cst-storefront-mock .product-tab-html h5 {

                        font-size: 0.83em;

                    }

                    .cst-storefront-mock .product-tab-html h6 {

                        font-size: 0.67em;

                    }

                    .cst-storefront-mock .product-tab-html .ql-align-center {

                        text-align: center;

                    }

                    .cst-storefront-mock .product-tab-html .ql-align-right {

                        text-align: right;

                    }

                    .cst-storefront-mock .product-tab-html .ql-align-justify {

                        text-align: justify;

                    }

                    .cst-storefront-mock .product-tab-html li.ql-align-center {

                        list-style-position: inside;

                    }

                    .cst-storefront-mock .product-tabs-nav {

                        display: flex;

                        flex-wrap: wrap;

                        border-bottom: 1px solid rgba(255, 255, 255, 0.12);

                        background: rgba(0, 0, 0, 0.35);

                    }

                    .cst-storefront-mock .product-tab-btn {

                        flex: 1 1 auto;

                        min-height: 48px;

                        padding: 0.65rem 0.75rem;

                        font-size: 1rem;

                        font-weight: 600;

                        letter-spacing: 0.06em;

                        text-transform: uppercase;

                        color: var(--text, #fff);

                        background: transparent;

                        border: none;

                        border-right: 1px solid rgba(255, 255, 255, 0.12);

                        cursor: default;

                        transition: background 0.2s, color 0.2s;

                    }

                    .cst-storefront-mock .product-tab-btn:last-child { border-right: none; }

                    .cst-storefront-mock .product-tab-btn.is-active {

                        background: var(--accent, #00ffff);

                        color: #000;

                    }

                    .cst-storefront-mock .product-tab-html ul,

                    .cst-storefront-mock .product-tab-html ol {

                        margin: 0 0 1rem;

                        padding-left: 1.75em;

                        list-style-position: outside;

                        text-align: left;

                    }

                    .cst-storefront-mock .product-tab-html ul {

                        list-style-type: disc;

                    }

                    .cst-storefront-mock .product-tab-html ol {

                        list-style-type: decimal;

                    }

                    .cst-storefront-mock .product-tab-html li {

                        display: list-item;

                        margin: 0 0 0.35rem;

                    }

                    .cst-storefront-mock .product-tab-html li .ql-ui {

                        display: none;

                    }

                    .cst-storefront-mock .product-tab-html ul > li::before,

                    .cst-storefront-mock .product-tab-html ol > li::before {

                        content: none !important;

                    }

                    .cst-storefront-mock .product-tab-html ul > li,

                    .cst-storefront-mock .product-tab-html ol > li {

                        list-style-type: inherit;

                        padding-left: 0;

                    }

                    .cst-storefront-mock .product-tab-html p { margin: 0 0 1rem; }

                    .cst-storefront-mock .product-tab-html h1,

                    .cst-storefront-mock .product-tab-html h2,

                    .cst-storefront-mock .product-tab-html h3,

                    .cst-storefront-mock .product-tab-html h4,

                    .cst-storefront-mock .product-tab-html h5,

                    .cst-storefront-mock .product-tab-html h6 {

                        color: var(--text, #fff);

                        margin: 0 0 0.75rem;

                        line-height: 1.25;

                    }

                    .cst-storefront-mock .product-tab-html blockquote {

                        margin: 0 0 1rem;

                        padding: 0.75rem 1rem;

                        border-left: 3px solid rgba(255, 255, 255, 0.25);

                        color: var(--text-muted, #ccc);

                    }

                    .cst-storefront-mock .product-tab-html img {

                        max-width: 100%;

                        height: auto;

                        border-radius: 4px;

                        margin: 0 0 1rem;

                    }

                    .cst-storefront-mock .product-tab-html table {

                        width: 100%;

                        border-collapse: collapse;

                        margin: 0 0 1rem;

                    }

                    .cst-storefront-mock .product-tab-html th,

                    .cst-storefront-mock .product-tab-html td {

                        border: 1px solid rgba(255, 255, 255, 0.15);

                        padding: 0.5rem 0.75rem;

                        text-align: left;

                        vertical-align: top;

                    }

                    .cst-storefront-mock .product-tab-html th {

                        background: rgba(255, 255, 255, 0.06);

                        color: var(--text, #fff);

                    }

                    .cst-storefront-mock .product-tab-html .jx-tab-cols {

                        display: grid;

                        gap: 1.25rem;

                        margin: 0 0 1.25rem;

                    }

                    .cst-storefront-mock .product-tab-html .jx-tab-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

                    .cst-storefront-mock .product-tab-html .jx-tab-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

                    .cst-storefront-mock .product-tab-html .jx-tab-col { min-width: 0; max-width: 100%; overflow-wrap: anywhere; word-break: break-word; }

                    .cst-storefront-mock .product-tab-html .jx-tab-col > :last-child { margin-bottom: 0; }

                    .cst-storefront-mock .product-tab-html .jx-tab-table {

                        width: 100%;

                        max-width: 100%;

                        table-layout: fixed;

                    }

                    .cst-storefront-mock .product-tab-html .jx-tab-callout {

                        padding: 1rem 1.1rem;

                        border-left: 3px solid var(--accent, #00e5ff);

                        background: rgba(0, 229, 255, 0.08);

                        margin: 0 0 1rem;

                        border-radius: 0 4px 4px 0;

                    }

                    .cst-storefront-mock .product-tab-html .jx-tab-divider {

                        border: none;

                        border-top: 1px solid rgba(255, 255, 255, 0.15);

                        margin: 1.25rem 0;

                    }

                    .cst-storefront-mock .product-tab-html .jx-tab-video iframe,

                    .cst-storefront-mock .product-tab-html .jx-tab-video-text iframe { display: block; }

                    .cst-storefront-mock .product-tab-html a { color: var(--accent, #00e5ff); }

                    .cst-storefront-mock .product-tab-html iframe {

                        max-width: 100%;

                        border: none;

                        border-radius: 4px;

                        aspect-ratio: 16 / 9;

                        width: min(100%, 560px);

                        height: auto;

                        min-height: 160px;

                        margin: 0 0 1rem;

                    }

                    .cst-panel-embedded .cst-html-textarea { min-height: 220px; }

                    .cst-panel-embedded .cst-design-panel,

                    .cst-panel-embedded .cst-design-canvas { min-height: 180px; }

                    .cst-panel-embedded .cst-tab-selector { margin-bottom: 8px; padding-bottom: 8px; }

                    @media (max-width: 767px) {

                        .cst-storefront-mock .product-tab-html .jx-tab-cols-2,

                        .cst-storefront-mock .product-tab-html .jx-tab-cols-3 { grid-template-columns: 1fr; }

                    }

                    @media (min-width: 768px) {

                        .cst-storefront-mock .product-tab-html .ql-video,

                        .cst-storefront-mock .product-tab-html iframe {

                            display: inline-block;

                            vertical-align: top;

                            width: calc(50% - 0.5rem);

                            margin-right: 1rem;

                        }

                        .cst-storefront-mock .product-tab-html .jx-tab-video iframe,

                        .cst-storefront-mock .product-tab-html .jx-tab-video-text iframe {

                            width: 100%;

                            margin-right: 0;

                        }

                    }

                    `}

                </style>

            </div>

        );

    }

}



export default CustomerSiteProductTabsPanel;


